import _objectSpread from "/opt/eazyads-player/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/opt/eazyads-player/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/opt/eazyads-player/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/opt/eazyads-player/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/eazyads-player/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array-buffer.constructor.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.string.search.js";
import PinchZoom from 'vue-pinch-zoom';
import QrcodeVue from 'qrcode.vue';
import pdf from 'vue-pdf';
import Youtube from '@/components/youtube';
import moment from 'moment';
import REQUEST from '@/utils/request';
import axios from 'axios'; // for HEAD request
import { getCookie, setCookie } from '@/utils/cookie-helper';
import { isConnected } from '@/utils/socketio';
import FileHelper from '@/utils/file-helper';
var FILE_HELPER = new FileHelper('eazyads');
import { getDevid, radians_to_degrees, sleep, executeAt, clearExecuteAt, shuffleArray, guessContentType, getLocalFileURL, object_equals, mergeObject } from '@/utils/various';
import { getLocation } from '@/utils/location-helper';
import { BleClient } from '@capacitor-community/bluetooth-le';
import { ActivityRecognition } from 'capacitor-activity-recognition';
// import { Motion } from '@capacitor/motion';  // Not working with plugin
import { Media } from 'capacitor-media';
import { Capacitor } from '@capacitor/core';
var platform = Capacitor.getPlatform();
import { Browser } from '@capacitor/browser';
var _window = window,
  RTCPeerConnection = _window.RTCPeerConnection,
  RTCSessionDescription = _window.RTCSessionDescription,
  RTCIceCandidate = _window.RTCIceCandidate;
import * as screenInfo from '@/utils/screen';
import $ from 'jquery';
var DEFAULT_DURATION = 10;
var default_play_options = {
  start_at: 0,
  scan_ble: false,
  controls: false,
  branding: true
};

// -- Define video.playing => https://stackoverflow.com/a/31196707
Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
  get: function get() {
    return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);
  }
});
// --

var attempts_play_cached = 0;
var caching_available;
function request(_x) {
  return _request.apply(this, arguments);
}
function _request() {
  _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee38(args) {
    var result;
    return _regeneratorRuntime().wrap(function _callee38$(_context38) {
      while (1) switch (_context38.prev = _context38.next) {
        case 0:
          if (!(caching_available == undefined)) {
            _context38.next = 10;
            break;
          }
          _context38.prev = 1;
          _context38.next = 4;
          return FILE_HELPER.isCachingAvailable();
        case 4:
          caching_available = true;
          _context38.next = 10;
          break;
        case 7:
          _context38.prev = 7;
          _context38.t0 = _context38["catch"](1);
          caching_available = false;
        case 10:
          if (!(args.method == 'GET' && caching_available)) {
            _context38.next = 37;
            break;
          }
          _context38.prev = 11;
          if (!(!isConnected() && (args.url.startsWith(process.env.VUE_APP_BASE_API) || !args.url.includes('://')))) {
            _context38.next = 14;
            break;
          }
          throw 'offline';
        case 14:
          if (!args.timeout) args.timeout = 1000;
          _context38.next = 17;
          return REQUEST(args);
        case 17:
          result = _context38.sent;
          _context38.next = 20;
          return FILE_HELPER.writeFile(args.url, JSON.stringify(result));
        case 20:
          return _context38.abrupt("return", result);
        case 23:
          _context38.prev = 23;
          _context38.t1 = _context38["catch"](11);
          _context38.prev = 25;
          _context38.next = 28;
          return FILE_HELPER.readJSONFile(args.url);
        case 28:
          result = _context38.sent;
          return _context38.abrupt("return", result);
        case 32:
          _context38.prev = 32;
          _context38.t2 = _context38["catch"](25);
          throw _context38.t1;
        case 35:
          _context38.next = 38;
          break;
        case 37:
          return _context38.abrupt("return", REQUEST(args));
        case 38:
        case "end":
          return _context38.stop();
      }
    }, _callee38, null, [[1, 7], [11, 23], [25, 32]]);
  }));
  return _request.apply(this, arguments);
}
export default {
  name: 'Player',
  components: {
    pdf: pdf,
    QrcodeVue: QrcodeVue,
    PinchZoom: PinchZoom,
    Youtube: Youtube
  },
  watch: {
    playing_media: function playing_media(val) {
      // Debug purpose: We wanted to see when playing_media values are changed because clearMediaTimeout is called very often and there this flag is resetted
      // alert(val)
    }
  },
  computed: {
    qr_size: function qr_size() {
      var ret = this.innerWidth / 100 * 80;
      if (ret > 500) ret = 500;
      if (ret > this.innerHeight / 100 * 45) ret = this.innerHeight / 100 * 45;
      return ret;
    }
  },
  data: function data() {
    return {
      streams: {},
      breaking_news: {},
      subtitles_style: {},
      subscription: {},
      fileHelper: FILE_HELPER,
      screen_id: getCookie('screen_id') || '',
      fallback_text: undefined,
      fallback_qr_url: undefined,
      innerWidth: window.innerWidth,
      innerHeight: window.innerHeight,
      schedule: undefined,
      mediaTimeout: undefined,
      html_content: undefined,
      pdf_src: undefined,
      pdf_page: 1,
      devid: undefined,
      isFlat: undefined,
      isMoving: undefined,
      activity: undefined,
      playing_playlist: false,
      playing_media: false,
      albums: undefined,
      date: undefined,
      time: undefined
    };
  },
  created: function created() {
    var _this = this;
    this.show(); // Hide all

    this.sockets.subscribe('subscription_changed', /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(data) {
        var subscription_bak;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              subscription_bak = _this.subscription;
              _context.next = 3;
              return _this.retrieveSubscription();
            case 3:
              if (_this.subscription._id != subscription_bak._id) _this.seekCurrentSchedulePosition();
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x2) {
        return _ref.apply(this, arguments);
      };
    }());
    this.sockets.subscribe('schedule_changed', function (data) {
      var tmp = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!_this.schedule || !data || !object_equals(_this.schedule, data))) {
                  _context2.next = 10;
                  break;
                }
                _this.medias = undefined;
                _this.medias_index = undefined;
                _this.ads = undefined;
                _this.ad_index = undefined;
                if (!_this.callback_caller) {
                  _context2.next = 8;
                  break;
                }
                _context2.next = 8;
                return _this.callback_caller({
                  success: false,
                  err: 'Schedule changed',
                  end_loop: true
                });
              case 8:
                //this.pauseVideo(true)
                //this.clearMediaTimeout()
                _this.show(); // hide all elements
                _this.setSchedule(data);
              case 10:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function tmp() {
          return _ref2.apply(this, arguments);
        };
      }();
      if (_this.mounted) tmp();else _this.mounted_listener = tmp;
    });
    this.sockets.subscribe('breaking_news', /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(data) {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              //this.show_breaking_news(data.text, data.style, data.animStyle)
              _this.show_breaking_news(data);
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }());
    this.sockets.subscribe('syn', function (data) {
      // Threeway handshake (sync timediff to server)
      var now = new Date();
      var diff = now.valueOf() - data.timestamp;
      if (diff < 100 && diff > -100) diff = 0; // neglegt smaller diff (just delay because of communication time)
      _this.ts_diff = diff;
      setCookie('ts_diff', _this.ts_diff, {
        expires: 365
      }); // Store here already in case we don't receive ack
      var t1 = new Date();
      _this.$socket.emit('syn_ack', {
        timestamp: now.valueOf(),
        d: diff
      });
      // this.$socket.once not triggering
      _this.sockets.subscribe('ack', function (ack_data) {
        var t2 = new Date();
        _this.sockets.unsubscribe('ack');
        var communication_time = t2 - t1;
        var diff = t2 - ack_data.timestamp;
        _this.ts_diff = diff - communication_time;
        if (_this.ts_diff < 100 && _this.ts_diff > -100) _this.ts_diff = 0; // neglegt smaller diff (just delay because of communication time)
        console.log("D=" + _this.ts_diff + ' ws'); // ws = Websocket
        setCookie('ts_diff', _this.ts_diff, {
          expires: 365
        });
      });
    });
    this.sockets.subscribe('report_preview', /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(data) {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this.reportPreview(data.response_type);
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function (_x4) {
        return _ref4.apply(this, arguments);
      };
    }());
    this.sockets.subscribe('rc', function (data) {
      if (data && data.action) {
        // Avoid ping pong (remote_control > preview > remote_control > preview ...) (actually only interesting for play/pause as we want next/prev to trigger reportPreview)
        // Does actually not really disturb but will report preview 2-3 times unneccesarily
        // 07.04.2023 08:30 - Report required - in case we have multiple managers open at the same time all must be notified about the update
        _this.rc_event_id = data.id;
        switch (data.action) {
          case 'pause':
            _this.pauseVideo();
            break;
          case 'play':
            if (data.currentTime) _this.seekTo(data.currentTime);
            _this.resumeVideo();
            break;
          case 'next':
            if (_this.onNext) _this.onNext();
            break;
          case 'prev':
            if (_this.onPrev) _this.onPrev();
            break;
        }
        if (!_this.reset_rc_event_id_timeout) clearTimeout(_this.reset_rc_event_id_timeout);
        _this.reset_rc_event_id_timeout = setTimeout(function () {
          _this.rc_event_id = undefined;
        }, 3000);
      }
    });
  },
  destroyed: function destroyed() {
    this.sockets.unsubscribe('syn');
    this.sockets.unsubscribe('subscription_changed');
    this.sockets.unsubscribe('schedule_changed');
    this.sockets.unsubscribe('breaking_news');
    this.sockets.unsubscribe('report_preview');
    this.sockets.unsubscribe('rc');
  },
  mounted: function mounted() {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var albums, init_with_schedule;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            console.log("".concat(moment().format('DD.MM.YYYY HH:mm:ss')));
            _this2.video_stream_clone = document.querySelector('#video_stream').cloneNode();
            _context5.prev = 2;
            $('.pinch-zoom-content').addClass('viewer'); // Dynamically add viewer class to pinch-zoom child (image wrapper) to center content
            _context5.prev = 4;
            _context5.next = 7;
            return Media.getAlbums();
          case 7:
            albums = _context5.sent;
            _this2.$socket.emit('configChanged', {
              albums: albums.albums
            });
            _this2.albums = albums;
            _context5.next = 14;
            break;
          case 12:
            _context5.prev = 12;
            _context5.t0 = _context5["catch"](4);
          case 14:
            // await this.sync_time()   // Handled by socket connect (main.vue)
            _this2.ts_diff = parseInt(getCookie('ts_diff') || 0);
            if (isNaN(_this2.ts_diff)) _this2.ts_diff = 0;
            _context5.next = 18;
            return _this2.retrieveSubscription();
          case 18:
            init_with_schedule = _this2.schedule;
            if (init_with_schedule) {
              _context5.next = 28;
              break;
            }
            _context5.prev = 20;
            _context5.next = 23;
            return FILE_HELPER.readJSONFile('schedule');
          case 23:
            init_with_schedule = _context5.sent;
            _context5.next = 28;
            break;
          case 26:
            _context5.prev = 26;
            _context5.t1 = _context5["catch"](20);
          case 28:
            // Mounted needs to be finished
            // Make sure ready event is called so that intro is not interrupted
            if (!_this2.playing_media && !_this2.mounted_listener && _this2.ready) _this2.setSchedule(init_with_schedule, false);
            _context5.next = 31;
            return getDevid();
          case 31:
            _this2.devid = _context5.sent;
            _context5.prev = 32;
            _context5.next = 35;
            return _this2.initMotionListener();
          case 35:
            _context5.next = 37;
            return _this2.initAR();
          case 37:
            _context5.next = 39;
            return BleClient.initialize({
              androidNeverForLocation: true
            });
          case 39:
            _context5.next = 43;
            break;
          case 41:
            _context5.prev = 41;
            _context5.t2 = _context5["catch"](32);
          case 43:
            _context5.next = 47;
            break;
          case 45:
            _context5.prev = 45;
            _context5.t3 = _context5["catch"](2);
          case 47:
            _this2.mounted = true;
            if (_this2.mounted_listener) {
              _this2.mounted_listener();
              _this2.mounted_listener = undefined;
            }
          case 49:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[2, 45], [4, 12], [20, 26], [32, 41]]);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    var _this3 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _this3.pauseVideo(true);
            _this3.clearMediaTimeout({
              comment: "beforeDestroy"
            });
            _this3.clearStartTimeout();
            _this3.clearEndTimeout();
            _this3.clearClockInterval();
            _context6.next = 7;
            return _this3.destroyMotionListener();
          case 7:
            _context6.next = 9;
            return _this3.destroyAR();
          case 9:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }))();
  },
  methods: {
    getEnv: function getEnv() {
      return process.env;
    },
    onReady: function onReady() {
      this.ready = true;
      if (this.ready_listener) {
        this.ready_listener();
        this.ready_listener = undefined;
      }
    },
    sync_time: function sync_time() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var t1, response, t2, request_time;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              t1 = new Date();
              _context7.next = 4;
              return REQUEST({
                url: '/time',
                method: 'GET',
                silent: true
              });
            case 4:
              response = _context7.sent;
              t2 = new Date();
              request_time = t2 - t1;
              _this4.ts_diff = t2 - response.timestamp - request_time;
              if (_this4.ts_diff < 100 && _this4.ts_diff > -100) _this4.ts_diff = 0; // neglegt smaller diff (just delay because of communication time)
              setCookie('ts_diff', _this4.ts_diff, {
                expires: 365
              });
              console.log("D=" + _this4.ts_diff + ' r'); // r = REST
              _context7.next = 16;
              break;
            case 13:
              _context7.prev = 13;
              _context7.t0 = _context7["catch"](0);
              _this4.ts_diff = parseInt(getCookie('ts_diff') || 0);
            case 16:
            case "end":
              return _context7.stop();
          }
        }, _callee7, null, [[0, 13]]);
      }))();
    },
    openURL: function openURL(url) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!(platform != 'web')) {
                _context8.next = 5;
                break;
              }
              _context8.next = 3;
              return Browser.open({
                'url': url
              });
            case 3:
              _context8.next = 6;
              break;
            case 5:
              // Not working on iOS
              window.open(url);
            case 6:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    initMotionListener: function initMotionListener() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var video_elem, video_overlay, listener;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              video_elem = $('#video')[0];
              video_overlay = $('#video_overlay')[0];
              _this5.resizeListener = function () {
                video_overlay.setAttribute("style", "width:".concat(video_elem.offsetWidth, "px; height:").concat(video_elem.offsetHeight, "px;"));
                _this5.innerWidth = window.innerWidth;
                _this5.innerHeight = window.innerHeight;
                if (_this5.$socket) {
                  var orientation = screenInfo.getOrientation();
                  var screenSize = screenInfo.getScreenSize();
                  if (_this5.orientation != orientation || !object_equals(_this5.screenSize, screenSize)) {
                    _this5.$socket.emit('configChanged', {
                      orientation: screenInfo.getOrientation(),
                      screenSize: screenInfo.getScreenSize()
                    });
                    _this5.orientation = orientation;
                    _this5.screenSize = screenSize;
                  }
                }
              };
              window.addEventListener("resize", _this5.resizeListener);
              if (!(DeviceMotionEvent && DeviceMotionEvent.requestPermission)) {
                _context9.next = 8;
                break;
              }
              _context9.next = 8;
              return DeviceMotionEvent.requestPermission();
            case 8:
              _this5.orientationListener = function (e) {
                // console.log("Orientation changed: " + e)
                var orientation = screenInfo.getOrientation();
                if (_this5.$socket && _this5.orientation != orientation) {
                  _this5.$socket.emit('configChanged', {
                    orientation: orientation
                  });
                  _this5.orientation = orientation;
                }
              };
              window.addEventListener('deviceorientation', _this5.orientationListener);
              listener = function listener(e) {
                var x = e.acceleration.x;
                var y = e.acceleration.y;
                var z = e.acceleration.z;
                var norm_Of_g = Math.sqrt(x * x + y * y + z * z);

                // Normalize the accelerometer vector
                x = x / norm_Of_g;
                y = y / norm_Of_g;
                z = z / norm_Of_g;
                var inclination = Math.round(radians_to_degrees(Math.acos(z)));
                if (!isNaN(inclination)) {
                  _this5.isFlat = inclination < 25 || inclination > 155;
                  // console.log("isFlat: " + this.isFlat + ': ' + inclination)
                } else {
                  _this5.isFlat = undefined;
                }
              }; //this.motionListener = await Motion.addListener('accel', listener)       // Plugin not working
              // -- Workaround: using directly browser API
              _this5.motionListener = listener;
              window.addEventListener('devicemotion', _this5.motionListener);
              // --
              _context9.next = 19;
              break;
            case 15:
              _context9.prev = 15;
              _context9.t0 = _context9["catch"](0);
              // Handle error
              console.log(_context9.t0);
              return _context9.abrupt("return");
            case 19:
            case "end":
              return _context9.stop();
          }
        }, _callee9, null, [[0, 15]]);
      }))();
    },
    destroyMotionListener: function destroyMotionListener() {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              // Plugin not working
              //if (this.motionListener)
              //  this.motionListener.remove();
              window.removeEventListener('devicemotion', _this6.motionListener);
              _this6.motionListener = undefined;
              window.removeEventListener('deviceorientation', _this6.orientationListener);
              _this6.orientationListener = undefined;
              window.removeEventListener("resize", _this6.resizeListener);
              _this6.resizeListener = undefined;
            case 6:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    // --- Activity Recognition
    initAR: function initAR() {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.prev = 0;
              _context11.next = 3;
              return ActivityRecognition.addListener("onActivity", function (data) {
                // console.log("ActivityRecognition: Activity detected => " + JSON.stringify(data));
                // this.showToast(JSON.stringify(data))
                _this7.isMoving = data.type == 'IN_VEHICLE' || data.type == 'ON_BICYCLE' || data.type == 'ON_FOOT';
                _this7.activity = data.type;
              });
            case 3:
              _this7.arListener = _context11.sent;
              console.log('ActivityRecognition: start called');
              ActivityRecognition.start().then(function (result) {
                _this7.isMoving = false;
                _this7.activity = undefined;
                // console.log('ActivityRecognition: ' + JSON.stringify(result))
              }).catch(function (e) {
                // console.log('ActivityRecognition: Error => ' + e)
              });
              _context11.next = 10;
              break;
            case 8:
              _context11.prev = 8;
              _context11.t0 = _context11["catch"](0);
            case 10:
            case "end":
              return _context11.stop();
          }
        }, _callee11, null, [[0, 8]]);
      }))();
    },
    destroyAR: function destroyAR() {
      if (this.arListener) {
        if (this.arListener.remove) {
          this.arListener.remove();
        }
        console.log('ActivityRecognition: stop called');
        ActivityRecognition.stop();
        this.arListener = undefined;
        this.isMoving = undefined;
        this.activity = undefined;
      }
    },
    // ---
    // -----
    pause: function pause() {
      var _this8 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.prev = 0;
              console.log("BLE: stopScan called");
              _context12.next = 4;
              return BleClient.stopLEScan();
            case 4:
              _context12.next = 9;
              break;
            case 6:
              _context12.prev = 6;
              _context12.t0 = _context12["catch"](0);
              console.log("BLE: error while stopScan: " + _context12.t0);
            case 9:
              if (_this8.callback_caller) _this8.callback_caller({
                success: false,
                end_loop: true
              });
              if (_this8.cleanup) _this8.cleanup();
              _this8.clearMediaTimeout({
                comment: "pause"
              });
              _this8.clearStartTimeout();
              _this8.clearEndTimeout();
              _this8.clearClockInterval();
              _this8.pauseVideo(true);
              _context12.next = 18;
              return _this8.destroyMotionListener();
            case 18:
              _context12.next = 20;
              return _this8.destroyAR();
            case 20:
            case "end":
              return _context12.stop();
          }
        }, _callee12, null, [[0, 6]]);
      }))();
    },
    resume: function resume() {
      var _this9 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              // Resume is automatically called at first start
              // console.log('AdFlow: App resumed')
              // await this.sync_time()   // Handled by socket connect (main.vue)
              _this9.initMotionListener();
              _this9.initAR();

              // 13.08.2023 18:50 - Don't call seek here as it gets double called (ready event is triggered and setSchedule will be triggered by server)
              // 14.08.2023 00:40 - Correction: Sometimes server may not respond to ready event (e.g. if offline or server overload) - make sure content is playing. playMedia will prevent double call of same media now
              if (_this9.schedule) _this9.seekCurrentSchedulePosition();else _this9.playing_playlist = false;
            case 3:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    // ---------
    toggleVideo: function toggleVideo() {
      var _this10 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var report;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              report = false;
              if (!$('#youtube').is(":visible")) {
                _context14.next = 6;
                break;
              }
              if (_this10.$refs.youtube.isPlaying()) _this10.$refs.youtube.pause();else _this10.$refs.youtube.play();
              report = true;
              _context14.next = 23;
              break;
            case 6:
              if (!($('#video').is(":visible") && $('#video')[0])) {
                _context14.next = 15;
                break;
              }
              if ($('#video')[0].paused) {
                _context14.next = 11;
                break;
              }
              $('#video')[0].pause();
              _context14.next = 13;
              break;
            case 11:
              _context14.next = 13;
              return $('#video')[0].play();
            case 13:
              report = true;
              console.log('Toggling video: Paused=' + $('#video')[0].paused);
            case 15:
              if (!($('#video_stream').is(":visible") && $('#video_stream')[0])) {
                _context14.next = 23;
                break;
              }
              if ($('#video_stream')[0].paused) {
                _context14.next = 20;
                break;
              }
              $('#video_stream')[0].pause();
              _context14.next = 22;
              break;
            case 20:
              _context14.next = 22;
              return $('#video_stream')[0].play();
            case 22:
              console.log('Toggling video stream: Paused=' + $('#video_stream')[0].paused);
            case 23:
              if (report) {
                // Will be reported in video_elem.onplay/onpause
                // this.reportPreview()
              }
            case 24:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }))();
    },
    pauseVideo: function pauseVideo() {
      var stop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var video_elements = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['#video', '#video_stream', '#youtube'];
      var resolve_play_promise = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var report = false;
      var video_elems = Array.isArray(video_elements) ? video_elements : [video_elements];
      for (var i = 0; i < video_elems.length; i++) {
        if (video_elems[i] == '#youtube' && this.$refs.youtube) {
          if (this.$refs.youtube.isPlaying()) report = true;
          if (stop) this.$refs.youtube.stop();else this.$refs.youtube.pause();
        } else {
          var video_elem = $(video_elems[i]);
          if (video_elem.is(":visible") && video_elem[0]) {
            if (video_elems[i] == '#video') {
              if (stop) {
                // We need to resolve this promise, otherwise this promise might be resolved with the next video. This may lead to wrong impression stats for foreign ads
                if (this.callback_caller && resolve_play_promise) this.callback_caller({
                  success: false,
                  err: 'Video stopped'
                });
                this.clearVideoLoadTimeout();
              } else if (!video_elem[0].paused) report = true;
            }
            video_elem[0].pause();
            if (stop) {
              // -- Clean video element properly => https://stackoverflow.com/a/28060352/5331765
              video_elem[0].removeAttribute('src'); // empty source
              while (video_elem[0].firstChild) {
                video_elem[0].removeChild(video_elem[0].lastChild);
              }
              video_elem[0].load();
              // --
            }

            console.log((stop ? 'Stopping ' : 'Pausing ') + video_elems[i] + ': Paused=' + video_elem[0].paused);
          }
        }
      }
      if (report) {
        // Will be reported in video_elem.onplay/onpause
        // this.reportPreview()
      }
    },
    resumeVideo: function resumeVideo() {
      var _arguments = arguments,
        _this11 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var video_elements, report, video_elems, i, video_elem;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              video_elements = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : ['#video', '#video_stream', '#youtube'];
              report = false;
              video_elems = Array.isArray(video_elements) ? video_elements : [video_elements];
              i = 0;
            case 4:
              if (!(i < video_elems.length)) {
                _context15.next = 20;
                break;
              }
              video_elem = $(video_elems[i]);
              if (!video_elem.is(":visible")) {
                _context15.next = 17;
                break;
              }
              if (!(video_elems[i] == '#youtube')) {
                _context15.next = 12;
                break;
              }
              if (!_this11.$refs.youtube.isPlaying()) report = true;
              _this11.$refs.youtube.play();
              _context15.next = 17;
              break;
            case 12:
              if (!video_elem[0]) {
                _context15.next = 17;
                break;
              }
              if (video_elems[i] == '#video' && video_elem[0].paused) report = true;
              _context15.next = 16;
              return video_elem[0].play();
            case 16:
              console.log('Resuming ' + video_elems[i] + ': Paused=' + video_elem[0].paused);
            case 17:
              i++;
              _context15.next = 4;
              break;
            case 20:
              if (report) {
                // Will be reported in video_elem.onplay/onpause
                // this.reportPreview()
              }
            case 21:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }))();
    },
    // ---------
    inPlaylist: function inPlaylist() {
      return this.playing_playlist;
    },
    isPlaying: function isPlaying() {
      return this.playing_media;
    },
    setSchedule: function setSchedule(schedule) {
      var cache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      // Cache schedule for offline usage (no need to await storage)
      if (cache) {
        if (schedule) FILE_HELPER.writeFile('schedule', JSON.stringify(schedule));else
          // When schedule is removed we can delete the cached schedule
          FILE_HELPER.deleteFile('schedule').catch(function (e) {});
      }
      this.schedule = schedule;
      this.$emit("onStatusChanged", {
        update_can_play_offline: true
      }); // force main.vue to update can_play_offline as schedule may have changed
      this.seekCurrentSchedulePosition();
    },
    seekCurrentSchedulePosition: function (_seekCurrentSchedulePosition) {
      function seekCurrentSchedulePosition() {
        return _seekCurrentSchedulePosition.apply(this, arguments);
      }
      seekCurrentSchedulePosition.toString = function () {
        return _seekCurrentSchedulePosition.toString();
      };
      return seekCurrentSchedulePosition;
    }(function () {
      var _arguments2 = arguments,
        _this12 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        var cleanup_stream, medias, i, show_ads_after_x_media, ads, a, result, url, albums, now, _this12$filterEntries, filtered_entries, next_entry, random_entry, tmp_random_entry, playlist, how_often_played_playlist, ellapsed_time_in_current_playlist, sum, playing_media, ellapsed_time_in_current_media, onEndLoop, duration, delay, ad_index, recheck_after_x_fillers, filler_count, new_ads, _ads, timeTillPlaylist;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              cleanup_stream = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : true;
              if (cleanup_stream && _this12.cleanup) _this12.cleanup();
              if (!_this12.interrupted) {
                _context16.next = 4;
                break;
              }
              return _context16.abrupt("return");
            case 4:
              if (_this12.isPlayerVisible()) {
                _context16.next = 6;
                break;
              }
              return _context16.abrupt("return");
            case 6:
              _context16.t0 = !_this12.$socket.connected;
              if (!_context16.t0) {
                _context16.next = 11;
                break;
              }
              _context16.next = 10;
              return _this12.canPlayOffline();
            case 10:
              _context16.t0 = !_context16.sent;
            case 11:
              if (!_context16.t0) {
                _context16.next = 14;
                break;
              }
              // We are unable to play a playlist (e.g. currently no block and next block is sales but we are offline)
              // main.vue will have to refresh can_play_offline variable to make sure "Waiting for server" will show up
              _this12.$emit("onStatusChanged", {
                update_can_play_offline: true
              });
              return _context16.abrupt("return");
            case 14:
              _context16.prev = 14;
              if (!(_this12.subscription._id == 'unlicensed')) {
                _context16.next = 18;
                break;
              }
              _this12.showFallback(_this12.subscription._id, process.env.VUE_APP_APP_URL + '/account/');
              return _context16.abrupt("return");
            case 18:
              //alert(this.schedule + ' ' + this.playing_media)
              _this12.playing_playlist = false;
              if (!(_this12.schedule && _this12.schedule.identifier)) {
                _context16.next = 87;
                break;
              }
              // Play local album
              _this12.playing_playlist = true;
              _context16.next = 23;
              return Media.getMedias({
                albumIdentifier: _this12.schedule.identifier
              });
            case 23:
              medias = _context16.sent;
              if (!(medias && medias.medias && medias.medias.length)) {
                _context16.next = 84;
                break;
              }
              if (_this12.schedule.random == true) {
                shuffleArray(medias.medias);
              }
              console.log("Playing local album ".concat(_this12.schedule.name, " with ").concat(medias.medias.length, " medias"));
              i = 0;
            case 28:
              if (!(i < medias.medias.length)) {
                _context16.next = 71;
                break;
              }
              _context16.prev = 29;
              if (!(_this12.schedule.show_ads == true)) {
                _context16.next = 47;
                break;
              }
              show_ads_after_x_media = Math.min(_this12.schedule.show_ads_after_x_media || 5, medias.length - 1);
              if (!(i % show_ads_after_x_media == 0 && i != 0)) {
                _context16.next = 47;
                break;
              }
              _context16.next = 35;
              return _this12.requestAds({
                type: 'filler'
              });
            case 35:
              ads = _context16.sent;
              a = 0;
            case 37:
              if (!(ads && a < ads.length)) {
                _context16.next = 47;
                break;
              }
              _context16.next = 40;
              return _this12.playAd(ads[a]);
            case 40:
              result = _context16.sent;
              if (!result.end_loop) {
                _context16.next = 44;
                break;
              }
              _this12.playing_playlist = false;
              return _context16.abrupt("return");
            case 44:
              a++;
              _context16.next = 37;
              break;
            case 47:
              _context16.next = 51;
              break;
            case 49:
              _context16.prev = 49;
              _context16.t1 = _context16["catch"](29);
            case 51:
              _context16.prev = 51;
              while (i < 0) {
                i = medias.medias.length + i;
              }
              console.log("Local file index ".concat(i));
              url = medias.medias[i].data;
              url = getLocalFileURL(url);
              _context16.next = 58;
              return _this12.playMedia({
                url: url,
                duration: _this12.schedule.duration,
                caching: false,
                branding: true
              });
            case 58:
              result = _context16.sent;
              if (!result.end_loop) {
                _context16.next = 62;
                break;
              }
              _this12.playing_playlist = false;
              return _context16.abrupt("return");
            case 62:
              if (result.prev) {
                i -= 2; // will be incremented to i-1 in for-loop
              } else if (result.next && i + 1 >= medias.medias.length) {
                // Force playing playlist from beginn
                i = -1; // will be incremented to 0 in for-loop
              }
              _context16.next = 68;
              break;
            case 65:
              _context16.prev = 65;
              _context16.t2 = _context16["catch"](51);
              console.log(_context16.t2);
            case 68:
              i++;
              _context16.next = 28;
              break;
            case 71:
              _context16.prev = 71;
              _context16.next = 74;
              return Media.getAlbums();
            case 74:
              albums = _context16.sent;
              if (!object_equals(albums, _this12.albums)) {
                _this12.$socket.emit('configChanged', {
                  albums: albums.albums
                });
                _this12.albums = albums;
              }
              _context16.next = 80;
              break;
            case 78:
              _context16.prev = 78;
              _context16.t3 = _context16["catch"](71);
            case 80:
              _this12.playing_playlist = false;
              _this12.seekCurrentSchedulePosition();
              _context16.next = 85;
              break;
            case 84:
              _this12.showFallback('album_empty');
            case 85:
              _context16.next = 282;
              break;
            case 87:
              if (!(_this12.schedule && _this12.schedule.entries)) {
                _context16.next = 281;
                break;
              }
              // calculate exact position in playlist with current local time and start playing
              now = moment();
              _this12$filterEntries = _this12.filterEntries(), filtered_entries = _this12$filterEntries.filtered_entries, next_entry = _this12$filterEntries.next_entry;
              if (!_this12.$socket.connected) {
                // To run foreign ads we must be online
                filtered_entries = filtered_entries.filter(function (x) {
                  return x.slot_type != 'sales';
                });
              }
              // console.log("ENTRIES=" + JSON.stringify(filtered_entries))

              // --- pick random entry if multiple playlists are found at current timestamp and make sure that an entry isn't took twice after each other if there are multiple entries (except we may continue in current ad feed? => commenting out as playlist shows up too rarely)

              if (filtered_entries && filtered_entries.length > 0) {
                do {
                  tmp_random_entry = filtered_entries[Math.floor(Math.random() * filtered_entries.length)];
                  if (filtered_entries.length == 1 || !_this12.last_playlist || _this12.last_playlist.playlist_id != tmp_random_entry.playlist_id /* || this.ads && tmp_random_entry.slot_type == 'sales'*/) random_entry = tmp_random_entry;
                } while (!random_entry);
              }
              _this12.last_playlist = random_entry;
              // ---
              if (!random_entry) {
                _context16.next = 278;
                break;
              }
              if (!random_entry.playlist_id) {
                _context16.next = 211;
                break;
              }
              _context16.next = 97;
              return request({
                url: '/playlists/' + random_entry.playlist_id,
                method: 'GET',
                silent: true
              });
            case 97:
              playlist = _context16.sent;
              if (!playlist) {
                _context16.next = 208;
                break;
              }
              how_often_played_playlist = random_entry.ellapsed / (playlist.duration * 1000);
              ellapsed_time_in_current_playlist = (how_often_played_playlist - parseInt(how_often_played_playlist)) * playlist.duration;
              console.log("".concat(moment(now).format('DD.MM.YYYY HH:mm:ss'), " Elapsed time in current playlist: ").concat(ellapsed_time_in_current_playlist, " / ").concat(playlist.duration));
              sum = 0;
              for (i = 0; i < playlist.media.length && sum <= ellapsed_time_in_current_playlist; i++) {
                playing_media = playlist.media[i];
                sum += playing_media.duration * (playing_media.page_count || 1);
              }
              ellapsed_time_in_current_media = sum - ellapsed_time_in_current_playlist; // -- precache all medias
              setTimeout(function () {
                _this12.downloadPlaylist(playlist);
              }, 1000);
              // --

              _this12.playing_playlist = true;

              // -- Random
              onEndLoop = function onEndLoop(medias, index) {
                _this12.playing_playlist = false;
                // Check if we were in a random loop, if yes then remember current playlist position
                if (random_entry.random) {
                  _this12.current_playlist = random_entry.playlist_id;
                  _this12.medias = medias;
                  _this12.medias_index = index;
                }
              };
              if (!(_this12.current_playlist == playlist._id && _this12.medias && _this12.medias_index != undefined)) {
                _context16.next = 116;
                break;
              }
              console.log("Reloading existing shuffle");
              medias = _this12.medias;
              i = _this12.medias_index;
              _this12.medias = undefined;
              _this12.medias_index = undefined;
              _context16.next = 147;
              break;
            case 116:
              medias = playlist.media;
              if (!(random_entry.random == true)) {
                _context16.next = 123;
                break;
              }
              medias = JSON.parse(JSON.stringify(medias));
              shuffleArray(medias);
              i = 0;
              _context16.next = 147;
              break;
            case 123:
              // -- play playlist from position {ellapsed_time_in_current_playlist}
              _this12.current_playlist = random_entry.playlist_id;
              _this12.setEndTimeout(random_entry.end, _this12.current_playlist);
              if (!playing_media) {
                _context16.next = 141;
                break;
              }
              duration = playing_media.duration * (playing_media.page_count || 1);
              delay = duration - ellapsed_time_in_current_media;
              console.log("".concat(moment().format('DD.MM.YYYY HH:mm:ss'), " - Playing Media ").concat(i - 1, " - ").concat(playing_media._id ? playing_media._id : playing_media.url, " (").concat(delay.toFixed(2), "/").concat(duration, ")"));
              _context16.next = 131;
              return _this12.playMedia(playing_media, {
                start_at: delay,
                branding: true
              });
            case 131:
              result = _context16.sent;
              if (!result.end_loop) {
                _context16.next = 135;
                break;
              }
              onEndLoop(medias, i);
              return _context16.abrupt("return");
            case 135:
              if (!(result.success == false && result.network_error)) {
                _context16.next = 138;
                break;
              }
              _context16.next = 138;
              return sleep(1000);
            case 138:
              if (result.prev) i -= 2; // will be incremented to i-1 in for-loop
              else if (result.next && i + 1 >= medias.length) i = 0;
              _context16.next = 147;
              break;
            case 141:
              if (!(playlist.media.length == 0)) {
                _context16.next = 147;
                break;
              }
              url = playlist._id ? process.env.VUE_APP_APP_URL + '/playlists/' + playlist._id : undefined;
              _this12.showFallback('playlist_empty', url);
              delay = DEFAULT_DURATION * 1000;
              _context16.next = 147;
              return sleep(delay);
            case 147:
              i;
            case 148:
              if (!(i < medias.length)) {
                _context16.next = 203;
                break;
              }
              if (i < 0) i = medias.length - 1;

              // --- if random_entry.show_ads => requestAds after every 5th item
              _context16.prev = 150;
              if (!(random_entry.show_ads == true)) {
                _context16.next = 172;
                break;
              }
              show_ads_after_x_media = Math.min(random_entry.show_ads_after_x_media || 5, medias.length - 1);
              if (!(i % show_ads_after_x_media == 0 && i != 0)) {
                _context16.next = 168;
                break;
              }
              _context16.next = 156;
              return _this12.requestAds({
                type: 'filler'
              });
            case 156:
              ads = _context16.sent;
              a = 0;
            case 158:
              if (!(ads && a < ads.length)) {
                _context16.next = 168;
                break;
              }
              _context16.next = 161;
              return _this12.playAd(ads[a]);
            case 161:
              result = _context16.sent;
              if (!result.end_loop) {
                _context16.next = 165;
                break;
              }
              onEndLoop(medias, i);
              return _context16.abrupt("return");
            case 165:
              a++;
              _context16.next = 158;
              break;
            case 168:
              if (random_entry.random) {
                _context16.next = 172;
                break;
              }
              _context16.next = 171;
              return seekCurrentSchedulePosition(cleanup_stream);
            case 171:
              return _context16.abrupt("return");
            case 172:
              _context16.next = 176;
              break;
            case 174:
              _context16.prev = 174;
              _context16.t4 = _context16["catch"](150);
            case 176:
              // ---

              playing_media = medias[i];
              duration = playing_media.duration * (playing_media.page_count || 1);
              console.log("".concat(moment().format('DD.MM.YYYY HH:mm:ss'), " - Playing Media ").concat(i, " - ").concat(playing_media._id ? playing_media._id : playing_media.url, " (0.00/").concat(duration.toFixed(2), ")"));
              _context16.next = 181;
              return _this12.playMedia(playing_media);
            case 181:
              result = _context16.sent;
              if (!result.end_loop) {
                _context16.next = 187;
                break;
              }
              onEndLoop(medias, i);
              return _context16.abrupt("return");
            case 187:
              if (!result.prev) {
                _context16.next = 191;
                break;
              }
              i -= 2; // will be incremented to i-1 in for-loop
              _context16.next = 200;
              break;
            case 191:
              if (!(result.next && i + 1 >= medias.length)) {
                _context16.next = 195;
                break;
              }
              // Force playing playlist from beginn
              i = -1; // will be incremented to 0 in for-loop
              _context16.next = 200;
              break;
            case 195:
              if (!(result.success == false && result.network_error)) {
                _context16.next = 200;
                break;
              }
              // Avoid net::ERR_INSUFFICIENT_RESOURCES (producable on webOS Emu 5.0)
              delay = 1000;
              if (i == medias.length - 1) {
                // if last media in this playlist wait longer and show fallback
                _this12.showFallback();
                delay = DEFAULT_DURATION * 1000;
              }
              _context16.next = 200;
              return sleep(delay);
            case 200:
              i++;
              _context16.next = 148;
              break;
            case 203:
              _this12.playing_playlist = false;
              _this12.current_playlist = undefined;
              // --
              _this12.seekCurrentSchedulePosition();
              _context16.next = 209;
              break;
            case 208:
              setTimeout(function () {
                _this12.seekCurrentSchedulePosition();
              }, 1000);
            case 209:
              _context16.next = 276;
              break;
            case 211:
              _this12.current_playlist = random_entry.slot_type;
              _this12.setEndTimeout(random_entry.end, _this12.current_playlist);

              // sales
              ad_index = 0;
              if (_this12.ads) {
                _context16.next = 222;
                break;
              }
              console.log("AdFlow: Requesting ads");
              _context16.next = 218;
              return _this12.requestAds(random_entry.exclude);
            case 218:
              ads = _context16.sent;
              console.log("AdFlow: Received ".concat(ads.length, " ads"));
              _context16.next = 226;
              break;
            case 222:
              // Continue in current ad feed
              ads = _this12.ads;
              ad_index = _this12.ad_index;
              _this12.ads = undefined;
              _this12.ad_index = undefined;
            case 226:
              if (!(ads.length > 0)) {
                _context16.next = 273;
                break;
              }
              recheck_after_x_fillers = 5;
              filler_count = 0;
              i = ad_index;
            case 230:
              if (!(i < ads.length)) {
                _context16.next = 270;
                break;
              }
              if (!(i >= 0 && i < ads.length && ads[i])) {
                _context16.next = 266;
                break;
              }
              console.log("AdFlow: Playing ad index ".concat(i, " (").concat(ads[i]._id, ")"));
              _context16.next = 235;
              return _this12.playAd(ads[i]);
            case 235:
              result = _context16.sent;
              if (!result.end_loop) {
                _context16.next = 241;
                break;
              }
              if (result.force_reseeking) _this12.seekCurrentSchedulePosition();else {
                _this12.ads = ads;
                _this12.ad_index = i + 1;
              }
              return _context16.abrupt("return");
            case 241:
              if (result.success) {
                if (ads[i].type == 'filler') filler_count++;else filler_count = 0;
              }
            case 242:
              if (!result.prev) {
                _context16.next = 246;
                break;
              }
              i -= 2; // will be incremented to i-1 in for-loop
              _context16.next = 264;
              break;
            case 246:
              if (!(result.next && i + 1 >= ads.length.length)) {
                _context16.next = 250;
                break;
              }
              // Force playing playlist from beginn
              i = -1; // will be incremented to 0 in for-loop
              _context16.next = 264;
              break;
            case 250:
              if (!(filler_count >= recheck_after_x_fillers && i < ads.length - recheck_after_x_fillers)) {
                _context16.next = 264;
                break;
              }
              _context16.prev = 251;
              _context16.next = 254;
              return _this12.requestAds({
                type: 'filler'
              });
            case 254:
              new_ads = _context16.sent;
              if (new_ads && new_ads.length > 0) {
                (_ads = ads).splice.apply(_ads, [i + 1, 0].concat(_toConsumableArray(new_ads)));
                // Reset filler_count as we have just now checked for new ads
                filler_count = 0;
              }
              if (!((!new_ads || !new_ads.find(function (x) {
                return x.type == 'ad';
              })) && filtered_entries && filtered_entries.length > 0)) {
                _context16.next = 260;
                break;
              }
              // new_ads will always contain at least a fallback so we need to explicitly check if array contains an ad
              // We still have other playlists running parallely, give them a chance to play but remember current position in news
              _this12.ads = ads;
              _this12.ad_index = i + 1;
              return _context16.abrupt("break", 270);
            case 260:
              _context16.next = 264;
              break;
            case 262:
              _context16.prev = 262;
              _context16.t5 = _context16["catch"](251);
            case 264:
              _context16.next = 267;
              break;
            case 266:
              if (i < 0) i = ads.length - 1;
            case 267:
              i++;
              _context16.next = 230;
              break;
            case 270:
              _this12.seekCurrentSchedulePosition();
              _context16.next = 275;
              break;
            case 273:
              _this12.showFallback();
              setTimeout(function () {
                _this12.seekCurrentSchedulePosition();
              }, DEFAULT_DURATION * 1000);
            case 275:
              _this12.current_playlist = undefined;
            case 276:
              _context16.next = 279;
              break;
            case 278:
              // We are outside of any schedule entry => show fallback and set timeout to recheck at next slot.start
              if (next_entry !== undefined) {
                timeTillPlaylist = function timeTillPlaylist() {
                  var time_till_start = next_entry.start - Date.now();
                  // return Intl.DurationFormat(navigator.language, { style: "digital" }).format(time_till_start)  // experimental
                  if (time_till_start < 60 * 1000) return moment.utc(time_till_start).format("HH:mm:ss"); // Does not show more than 24 hrs
                  return _this12.$options.filters.durationFilter(time_till_start);
                };
                _this12.showFallback("waiting_for_playlist", undefined, {
                  time_till_playlist: timeTillPlaylist()
                }, function () {
                  _this12.fallback_text = _this12.$t("waiting_for_playlist", {
                    time_till_playlist: timeTillPlaylist()
                  });
                });
                _this12.setStartTimeout(next_entry.start);
                _this12.downloadPlaylist(next_entry.playlist_id); // Precache playlist so that files are loaded when starting
              } else {
                url = _this12.schedule._id ? process.env.VUE_APP_APP_URL + '/schedules/' + _this12.schedule._id : undefined;
                _this12.showFallback("schedule_empty", url);
              }
            case 279:
              _context16.next = 282;
              break;
            case 281:
              if (!_this12.playing_media) _this12.showWaitingForSchedule();
            case 282:
              _context16.next = 289;
              break;
            case 284:
              _context16.prev = 284;
              _context16.t6 = _context16["catch"](14);
              console.log(_context16.t6);
              _this12.showFallback();
              setTimeout(function () {
                _this12.seekCurrentSchedulePosition();
              }, DEFAULT_DURATION * 1000);
            case 289:
            case "end":
              return _context16.stop();
          }
        }, _callee16, null, [[14, 284], [29, 49], [51, 65], [71, 78], [150, 174], [251, 262]]);
      }))();
    }),
    getAdRequestData: function getAdRequestData() {
      var _this13 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var screenSize, orientation, location, data;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              screenSize = screenInfo.getScreenSize();
              orientation = screenInfo.getOrientation();
              _context17.prev = 2;
              _context17.next = 5;
              return getLocation({
                timeout: 500
              });
            case 5:
              location = _context17.sent;
              _context17.next = 10;
              break;
            case 8:
              _context17.prev = 8;
              _context17.t0 = _context17["catch"](2);
            case 10:
              data = {};
              if (_this13.devid) data.devid = _this13.devid;
              if (orientation) data.orientation = orientation;
              if (screenSize) data.screenSize = screenSize;
              if (location) {
                data.lat = location.coords.latitude;
                data.lng = location.coords.longitude;
              }
              if (_this13.isFlat !== undefined) data.flat = _this13.isFlat;
              if (_this13.isMoving !== undefined) data.moving = _this13.isMoving;
              if (_this13.activity !== undefined) data.activity = _this13.activity;
              data.timezone_offset = new Date().getTimezoneOffset();
              data.exclude_styles = true; // Already loaded in main.vue, param required for elder versions
              return _context17.abrupt("return", data);
            case 21:
            case "end":
              return _context17.stop();
          }
        }, _callee17, null, [[2, 8]]);
      }))();
    },
    requestAds: function requestAds() {
      var _arguments3 = arguments,
        _this14 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        var exclude, data, ads;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              exclude = _arguments3.length > 0 && _arguments3[0] !== undefined ? _arguments3[0] : {};
              _context18.next = 3;
              return _this14.getAdRequestData();
            case 3:
              data = _context18.sent;
              data.exclude = exclude;
              _context18.next = 7;
              return request({
                url: '/ads/request',
                method: 'POST',
                silent: true,
                data: data
              });
            case 7:
              ads = _context18.sent;
              return _context18.abrupt("return", ads);
            case 9:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      }))();
    },
    downloadFile: function downloadFile(url) {
      var _this15 = this;
      // Prevent double downloading file (e.g. if file download is requested twice)
      // - Check download queue if there is already a promise for this file
      if (!this.downloadQueue) this.downloadQueue = {};

      // - if yes, return the existing promise
      if (this.downloadQueue[url]) return this.downloadQueue[url];

      // - if not, trigger download, queue the promise and return it
      var promise = this.fileHelper.getFile(url);
      this.downloadQueue[url] = promise;

      // - As soon as download is done, remove promise from queue
      promise.then(function () {
        delete _this15.downloadQueue[url];
      });
      return promise;
    },
    downloadPlaylist: function downloadPlaylist(playlist) {
      var _this16 = this;
      if (caching_available == false) return;
      this.fileHelper.isCachingAvailable().then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        var i, media, media_object;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              caching_available = true;
              if (!(!playlist.media && typeof playlist == 'string')) {
                _context19.next = 6;
                break;
              }
              if (!_this16.$socket.connected) {
                _context19.next = 6;
                break;
              }
              _context19.next = 5;
              return request({
                url: '/playlists/' + playlist,
                method: 'GET',
                silent: true
              });
            case 5:
              playlist = _context19.sent;
            case 6:
              i = 0;
            case 7:
              if (!(playlist && playlist.media && i < playlist.media.length)) {
                _context19.next = 34;
                break;
              }
              _context19.prev = 8;
              media = playlist.media[i];
              if (!(!_this16.$socket.connected && (!media.url || media.url.startsWith(process.env.VUE_APP_BASE_API)))) {
                _context19.next = 12;
                break;
              }
              return _context19.abrupt("continue", 31);
            case 12:
              if (media.url) {
                _context19.next = 22;
                break;
              }
              _context19.next = 15;
              return request({
                url: '/medias/' + media._id,
                method: 'GET',
                silent: true
              });
            case 15:
              media_object = _context19.sent;
              media.url = media_object.media;
              if (!media.duration && media_object.duration) media.duration = media_object.duration;
              if (!media.page_count && media_object.page_count) media.page_count = media_object.page_count;
              if (!media.content_type && media_object.content_type) media.content_type = media_object.content_type;
              if (!media.codecs && media_object.codecs) media.codecs = media_object.codecs;
              if (!media.fragmented && media_object.fragmented) media.fragmented = media_object.fragmented;
            case 22:
              if (_this16.$refs.youtube.getVideoID(media.url)) {
                _context19.next = 25;
                break;
              }
              _context19.next = 25;
              return _this16.downloadFile(media.url);
            case 25:
              _context19.next = 31;
              break;
            case 27:
              _context19.prev = 27;
              _context19.t0 = _context19["catch"](8);
              _context19.next = 31;
              return sleep(1000);
            case 31:
              i++;
              _context19.next = 7;
              break;
            case 34:
            case "end":
              return _context19.stop();
          }
        }, _callee19, null, [[8, 27]]);
      }))).catch(function (e) {});
    },
    interrupt: function interrupt(_data) {
      var _this17 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return new Promise( /*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee23(resolve) {
          var data, peerConnection, answer, video_elem_id, video, disconnect_handler, id, stream, cleanup, result, response_data;
          return _regeneratorRuntime().wrap(function _callee23$(_context23) {
            while (1) switch (_context23.prev = _context23.next) {
              case 0:
                mergeObject(default_play_options, options);
                data = _data; // if we name the argument data directly it is undefined for some reason
                // Interrupt by server to show a server controlled media
                if (!(!_this17.isPlayerVisible() || _this17.subscription._id == 'unlicensed')) {
                  _context23.next = 4;
                  break;
                }
                return _context23.abrupt("return");
              case 4:
                _context23.prev = 4;
                _this17.interrupted = true;
                if (!_this17.callback_caller) {
                  _context23.next = 9;
                  break;
                }
                _context23.next = 9;
                return _this17.callback_caller({
                  success: false,
                  err: 'Interrupted',
                  end_loop: true
                });
              case 9:
                if (!(data.type == 'rtc')) {
                  _context23.next = 25;
                  break;
                }
                if (_this17.cleanup) _this17.cleanup({
                  seek_schedule: false
                });
                _this17.clearMediaTimeout({
                  cleanup_stream: false,
                  stop_video: false,
                  comment: "RTC started"
                });
                // Prevent double calling events as rtc event needs to be called twice (after onnegotiationneeded)
                peerConnection = _this17.peerConnection ? _this17.peerConnection : new RTCPeerConnection(data.config);
                _this17.peerConnection = peerConnection;
                _context23.next = 16;
                return peerConnection.setRemoteDescription(new RTCSessionDescription(data.offer));
              case 16:
                _context23.next = 18;
                return peerConnection.createAnswer();
              case 18:
                answer = _context23.sent;
                _context23.next = 21;
                return peerConnection.setLocalDescription(answer);
              case 21:
                _this17.$socket.emit('rtc_answer', {
                  answer: answer
                });
                if (!data.negotiation) {
                  _this17.sockets.subscribe('rtc_candidate', function (data) {
                    if (data.candidate) {
                      peerConnection.addIceCandidate(new RTCIceCandidate(data.candidate)).catch(function (e) {});
                    }
                  });
                  _this17.sockets.subscribe('rtc_end', function (data) {
                    // --- Workaround: After starting WebRTC, camera via video stream isn't working anymore => Replace video_stream object by its original clone
                    var video = document.querySelector('#video_stream');
                    var parent = video.parentNode;
                    var video_new = _this17.video_stream_clone.cloneNode();
                    parent.replaceChild(video_new, video);
                    // ---
                    _this17.sockets.unsubscribe('rtc_candidate');
                    _this17.sockets.unsubscribe('rtc_end');
                    peerConnection.close();
                    peerConnection = undefined;
                    _this17.peerConnection = undefined;
                    _this17.interrupted = false;
                    _this17.seekCurrentSchedulePosition();
                    resolve({
                      success: true
                    });
                  });
                  peerConnection.onicecandidate = function (event) {
                    // https://github.com/sauravkp/WebRTC-nodejs-video-call-demo/blob/master/client/webrtc.js
                    // https://github.com/webrtc/samples/blob/gh-pages/src/content/peerconnection/pc1/js/main.js
                    _this17.$socket.emit('rtc_candidate', {
                      candidate: event.candidate
                    });
                  };
                  peerConnection.ontrack = function (_ref7) {
                    var _ref7$streams = _slicedToArray(_ref7.streams, 1),
                      stream = _ref7$streams[0];
                    var video_elem_id = '#video_stream';
                    var video = document.querySelector(video_elem_id);
                    if ("srcObject" in video) {
                      video.srcObject = stream;
                    } else {
                      video.src = window.URL.createObjectURL(stream);
                    }
                    video.onloadedmetadata = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
                      return _regeneratorRuntime().wrap(function _callee20$(_context20) {
                        while (1) switch (_context20.prev = _context20.next) {
                          case 0:
                            video.onloadedmetadata = undefined; // prevent onloadedmetadata to be recalled when RTC is ended
                            if (!_this17.peerConnection) {
                              _context20.next = 5;
                              break;
                            }
                            _context20.next = 4;
                            return _this17.show(video_elem_id);
                          case 4:
                            video.play().catch(function (e) {
                              video.muted = true;
                              video.play();
                            });
                          case 5:
                          case "end":
                            return _context20.stop();
                        }
                      }, _callee20);
                    }));
                  };
                }
                _context23.next = 39;
                break;
              case 25:
                if (!(data.type == 'stream')) {
                  _context23.next = 29;
                  break;
                }
                if (!_this17.preparingStream) {
                  if (_this17.cleanup) _this17.cleanup({
                    seek_schedule: true
                  });
                  _this17.preparingStream = true;
                  _this17.clearMediaTimeout({
                    cleanup_stream: false,
                    stop_video: false,
                    comment: "Stream started"
                  });
                  $('#loading').show();
                  video_elem_id = '#video_stream';
                  video = document.querySelector(video_elem_id);
                  video.controls = options.controls;
                  disconnect_handler = function disconnect_handler() {
                    _this17.seekCurrentSchedulePosition();
                  };
                  id = data.id;
                  stream = {
                    queue: [],
                    buffer: undefined,
                    mediaSource: new MediaSource(),
                    ended: false,
                    hasStarted: false
                  };
                  _this17.streams[id] = stream;
                  stream.object_url = window.URL.createObjectURL(_this17.streams[id].mediaSource);
                  video.src = stream.object_url;
                  video.load();
                  _this17.cleanup = function () {
                    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    var default_options = {
                      seek_schedule: true,
                      cleanup_stream: true,
                      err: undefined
                    };
                    mergeObject(default_options, options);

                    // Seek to current schedule position by default to avoid black screen while loading
                    _this17.cleanup = null;
                    _this17.preparingStream = false;
                    _this17.interrupted = false;
                    console.log("Cleaning " + id);
                    $('#loading').hide();
                    _this17.$socket.off('disconnect', disconnect_handler);
                    _this17.sockets.unsubscribe('data.' + id);
                    var data = {
                      devid: _this17.devid,
                      id: id
                    };
                    if (options.err) data.err = options.err;
                    _this17.$socket.emit('stop_stream', data);

                    //if (video.src == this.streams[id].object_url)
                    //this.pauseVideo(true, video_elem_id)   // Problems when stream overwrites another stream => Exception while appendBuffer: Buffer has been removed from parent
                    URL.revokeObjectURL(_this17.streams[id].object_url);
                    _this17.streams[id].mediaSource = null;
                    _this17.streams[id].buffer = null;
                    _this17.streams[id].queue = null;
                    _this17.streams[id].ended = true;
                    _this17.streams[id].object_url = null;
                    _this17.streams[id] = null;
                    if (options.seek_schedule) _this17.seekCurrentSchedulePosition();
                    resolve({
                      success: options.err ? true : false,
                      err: options.err
                    });
                  };
                  cleanup = function cleanup(err) {
                    if (_this17.cleanup) _this17.cleanup({
                      err: err,
                      seek_schedule: true
                    });
                  };
                  _this17.streams[id].mediaSource.addEventListener('sourceopen', function (e) {
                    // console.log(data['content-type'] + ' supported: ' + MediaSource.isTypeSupported(data['content-type']));
                    if (_this17.streams[id]) {
                      if (_this17.streams[id].mediaSource.readyState == 'open') {
                        try {
                          _this17.streams[id].buffer = _this17.streams[id].mediaSource.addSourceBuffer(data['content-type']);
                        } catch (e) {
                          _this17.cleanup({
                            err: e
                          });
                        }
                      }
                      if (_this17.streams[id] && _this17.streams[id].buffer) {
                        _this17.streams[id].buffer.mode = "segments";
                        _this17.streams[id].buffer.addEventListener('update', function () {
                          if (_this17.streams[id] && (!_this17.streams[id].buffer || !_this17.streams[id].buffer.updating)) {
                            if (_this17.streams[id].buffer && _this17.streams[id].queue.length > 0) _this17.streams[id].buffer.appendBuffer(_this17.streams[id].queue.shift());
                            // console.log((ended ? '' : 'NOT ') + 'ENDED: ' + queue.length)
                            if (!_this17.streams[id].buffer || !_this17.streams[id].buffer.updating && _this17.streams[id].queue.length == 0 && _this17.streams[id].ended) {
                              if (_this17.streams[id].mediaSource && _this17.streams[id].mediaSource.readyState == 'open') {
                                // console.log('END OF STREAM')
                                _this17.streams[id].mediaSource.endOfStream();
                              }
                            }
                          }
                        });
                      }
                    }
                    var canplay = /*#__PURE__*/function () {
                      var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
                        var success, trial, onPlayError;
                        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
                          while (1) switch (_context22.prev = _context22.next) {
                            case 0:
                              console.log("META LOADED");
                              success = /*#__PURE__*/function () {
                                var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
                                  return _regeneratorRuntime().wrap(function _callee21$(_context21) {
                                    while (1) switch (_context21.prev = _context21.next) {
                                      case 0:
                                        _this17.pauseVideo(true, ['#video', '#youtube'], false); // 17.08.2023 13:30 - Don't call callback_caller here as RTC stops working for some reason
                                        _this17.clearMediaTimeout({
                                          cleanup_stream: false,
                                          stop_video: false,
                                          comment: "Before playing video"
                                        });
                                        $('#loading').hide();
                                        _this17.preparingStream = false; // Stream can be interrupted from now on
                                        _context21.next = 6;
                                        return _this17.show(video_elem_id);
                                      case 6:
                                        if (_this17.streams[id]) _this17.streams[id].hasStarted = true;
                                      case 7:
                                      case "end":
                                        return _context21.stop();
                                    }
                                  }, _callee21);
                                }));
                                return function success() {
                                  return _ref10.apply(this, arguments);
                                };
                              }();
                              video.removeAttribute('autoplay');
                              if (!_this17.muteForced()) {
                                video.removeAttribute('muted');
                                video.volume = 1;
                              } else video.muted = true;
                              trial = 0;
                              onPlayError = function onPlayError(e) {
                                console.log(e);
                                if (!e || !String(e).includes("pause")) {
                                  // Don't play when "The play() request was interrupted by a call to pause()"
                                  trial++;
                                  if (trial >= 3) {
                                    console.log("Playing muted");
                                    video.autoplay = true;
                                    video.muted = true;
                                  }
                                  if (trial <= 5) video.play().then(function () {}).catch(onPlayError);else cleanup(e);
                                }
                              };
                              _context22.next = 8;
                              return success();
                            case 8:
                              video.play().then(function () {}).catch(onPlayError);
                              video.controls = options.controls;
                            case 10:
                            case "end":
                              return _context22.stop();
                          }
                        }, _callee22);
                      }));
                      return function canplay() {
                        return _ref9.apply(this, arguments);
                      };
                    }();
                    video.onloadedmetadata = canplay;
                    //video.addEventListener('canplay', canplay);   // canplay not called in iOS => use onloadedmetadata (also addEventListener would need to be unregistered)
                  }, false);
                  video.onended = function () {
                    cleanup();
                  };
                  video.onerror, function (e) {
                    console.log('Video Error: ' + video.error.message);
                    cleanup(e);
                  };
                  _this17.$socket.on('disconnect', disconnect_handler);
                  _this17.sockets.subscribe('data.' + id, function (chunks) {
                    if (chunks instanceof ArrayBuffer) {
                      // console.log("StreamID: " + id)
                      try {
                        if (!_this17.streams[id].buffer || _this17.streams[id].buffer.updating || _this17.streams[id].queue.length > 0) {
                          _this17.streams[id].queue.push(chunks);
                          if (_this17.streams[id].buffer && (_this17.streams[id].queue.length > 20 || _this17.streams[id].ended)) {
                            // queue.length > 20 => prebuffering to avoid hanging
                            // Initial push to buffer (required to work)
                            _this17.streams[id].buffer.appendBuffer(_this17.streams[id].queue.shift());
                          }
                        } else if (_this17.streams[id].buffer) {
                          _this17.streams[id].buffer.appendBuffer(chunks);
                        }
                      } catch (e) {
                        console.log(e);
                        cleanup(String(e));
                      }
                    } else if (chunks && chunks.close) {
                      $('#loading').hide();
                      _this17.$socket.off('disconnect', disconnect_handler);
                      _this17.sockets.unsubscribe('data.' + id);
                      // console.log('ENDED')
                      _this17.streams[id].ended = true;
                      if (_this17.streams[id].queue.length == 0 && (!_this17.streams[id].buffer || !_this17.streams[id].buffer.updating) && _this17.streams[id].mediaSource && _this17.streams[id].mediaSource.readyState == 'open') {
                        // console.log('END OF STREAM')
                        _this17.streams[id].mediaSource.endOfStream();
                      }
                      if (video.paused && _this17.streams[id] && _this17.streams[id].hasStarted) cleanup();
                    }
                  });
                }
                _context23.next = 39;
                break;
              case 29:
                if (_this17.cleanup) {
                  // Running stream was interrupted by media from user's galery => cleanup stream first, otherwise preparingStream may stay true
                  // Don't seek in schedule as it may overwrite the playMedia called in next line
                  _this17.cleanup({
                    seek_schedule: false
                  });
                }
                // pauseVideo + clearMediaTimeout is called by playMedia as soon as file is downloaded to avoid black screen while download
                if (data.callback_url != undefined) options.scan_ble = true;
                options.force_overwrite = true; // Force new playPromise even if same media
                _context23.next = 34;
                return _this17.playMedia(data, options);
              case 34:
                result = _context23.sent;
                _this17.interrupted = false;
                if (data.callback_url && result.success) {
                  // PUT /ads/request/:id => Ad delivered
                  response_data = {};
                  if (result.ble_count !== undefined) response_data.ble_count = result.ble_count;
                  if (_this17.isFlat !== undefined) response_data.flat = _this17.isFlat;
                  if (_this17.isMoving !== undefined) response_data.moving = _this17.isMoving;
                  if (_this17.activity !== undefined) response_data.activity = _this17.activity;
                  if (_this17.devid !== undefined) response_data.devid = _this17.devid;
                  request({
                    url: data.callback_url,
                    method: 'PUT',
                    silent: true,
                    data: response_data
                  }).catch(function (e) {});
                }
                if (!result.end_loop) _this17.seekCurrentSchedulePosition();
                resolve(result);
              case 39:
                _context23.next = 46;
                break;
              case 41:
                _context23.prev = 41;
                _context23.t0 = _context23["catch"](4);
                _this17.interrupted = false;
                _this17.seekCurrentSchedulePosition();
                resolve({
                  success: false,
                  err: _context23.t0
                });
              case 46:
              case "end":
                return _context23.stop();
            }
          }, _callee23, null, [[4, 41]]);
        }));
        return function (_x5) {
          return _ref6.apply(this, arguments);
        };
      }());
    },
    playAd: function playAd(ad) {
      var _this18 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
        var broadcast, data, result;
        return _regeneratorRuntime().wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              if (_this18.$socket.connected) {
                _context24.next = 2;
                break;
              }
              return _context24.abrupt("return", {
                success: false,
                end_loop: true,
                force_reseeking: true
              });
            case 2:
              if (!(ad.type == 'ad')) {
                _context24.next = 17;
                break;
              }
              _context24.prev = 3;
              _context24.next = 6;
              return _this18.getAdRequestData();
            case 6:
              data = _context24.sent;
              _context24.next = 9;
              return request({
                url: '/ads/request/' + ad._id,
                method: 'POST',
                silent: true,
                data: data
              });
            case 9:
              broadcast = true;
              _context24.next = 15;
              break;
            case 12:
              _context24.prev = 12;
              _context24.t0 = _context24["catch"](3);
              broadcast = false;
            case 15:
              _context24.next = 18;
              break;
            case 17:
              broadcast = true;
            case 18:
              // news/weather/fallback
              result = {
                success: false
              };
              if (!broadcast) {
                _context24.next = 24;
                break;
              }
              _context24.next = 22;
              return _this18.playMedia(ad, {
                scan_ble: ad._id !== undefined,
                branding: false
              });
            case 22:
              result = _context24.sent;
              if (result._id !== undefined && result.success) {
                // PUT /ads/request/:id => Ad delivered
                data = {};
                if (result.ble_count !== undefined) data.ble_count = result.ble_count;
                if (_this18.isFlat !== undefined) data.flat = _this18.isFlat;
                if (_this18.isMoving !== undefined) data.moving = _this18.isMoving;
                if (_this18.activity !== undefined) data.activity = _this18.activity;
                if (_this18.devid !== undefined) data.devid = _this18.devid;
                request({
                  url: '/ads/request/' + result._id,
                  method: 'PUT',
                  silent: true,
                  data: data
                }).catch(function (e) {});
              } else if (!result.success) {
                console.log("Ad ".concat(result._id, " cancelled"));
              }
            case 24:
              return _context24.abrupt("return", result);
            case 25:
            case "end":
              return _context24.stop();
          }
        }, _callee24, null, [[3, 12]]);
      }))();
    },
    reportPreview: function reportPreview() {
      var _arguments4 = arguments,
        _this19 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
        var response_type, preview;
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              response_type = _arguments4.length > 0 && _arguments4[0] !== undefined ? _arguments4[0] : 'REST';
              preview = _this19.getPreview();
              if (preview && preview.media && preview.media.url && preview.media.url.includes('://localhost/'))
                // don't report local media as we cannot preview them
                preview = undefined;
              if (!(response_type == 'REST')) {
                _context25.next = 8;
                break;
              }
              _context25.next = 6;
              return REQUEST({
                // We will identify the screen by the token
                url: '/screens/preview',
                method: 'POST',
                data: preview,
                silent: true
              });
            case 6:
              _context25.next = 9;
              break;
            case 8:
              if (response_type == 'WS') {
                _this19.$socket.emit('preview', preview);
              }
            case 9:
            case "end":
              return _context25.stop();
          }
        }, _callee25);
      }))();
    },
    getPreview: function getPreview() {
      // get info of current media and current position in media (for remote monitoring screen)
      var current_view = this.getCurrentView();
      if (current_view) {
        var display = {
          rc_event_id: this.rc_event_id,
          timestamp: Date.now() + this.ts_diff,
          media: this.current_media ? _objectSpread(_objectSpread({}, this.current_media), {}, {
            content_type: this.current_media_content_type
          }) : undefined,
          options: this.current_media_options,
          current_view: current_view.replace('#', '')
        };
        switch (current_view) {
          case '#fallback':
            display.fallback_text = this.fallback_text;
            display.fallback_qr_url = this.fallback_qr_url;
            break;
          case '#youtube':
            // currentPosition
            display.currentPosition = this.$refs.youtube.getCurrentTime();
            display.paused = !this.$refs.youtube.isPlaying();
            break;
          case '#video':
            // currentPosition
            var video_elem = $('#video')[0];
            display.currentPosition = video_elem.currentTime;
            display.paused = video_elem.paused;
            break;
          case '#pdf':
            // currentPosition, currentPage
            display.currentPage = this.pdf_page;
          case '#iframe':
          // currentPosition
          case '#img':
            // currentPosition
            display.currentPosition = (Date.now() - this.mediaTimeoutStart + this.ts_diff) / 1000;
            if (isNaN(display.currentPosition)) display.currentPosition = undefined;
            break;
          case '#video_stream':
          default:
            display = undefined;
            break;
        }
        return display;
      }
    },
    playMedia: function playMedia(media) {
      var _arguments5 = arguments,
        _this20 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee33() {
        var options;
        return _regeneratorRuntime().wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              options = _arguments5.length > 1 && _arguments5[1] !== undefined ? _arguments5[1] : {};
              mergeObject(default_play_options, options);
              if (!(!options.force_overwrite && _this20.playPromise && _this20.current_media && (_this20.current_media.url == media.url || _this20.current_media._id == media._id))) {
                _context33.next = 6;
                break;
              }
              return _context33.abrupt("return", _this20.playPromise);
            case 6:
              if (!_this20.callback_caller) {
                _context33.next = 9;
                break;
              }
              _context33.next = 9;
              return _this20.callback_caller({
                success: false,
                err: 'Started next media',
                end_loop: true
              });
            case 9:
              _this20.playPromise = new Promise( /*#__PURE__*/function () {
                var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee32(resolve) {
                  var t1, callback_called, success, ble_devices, onLoaded, unregisterListeners, callback_caller, media_object, content_type, url, mediaSource, sourceopen, data, showing_loader, data_url_match, mimeCodec, bg_download, queue, url_ori, response, t2, loading_time, start_at, page, iPage, rest, start_at_new, num_pages, setPDFLoadTimeout, clearPDFLoadTimeout, pdfNumPagesListener, pdfErrorListener, pdfPageRenderedListener, pdfLoadedListener, reader, same_img, onerror, onload, video_elem, source, trying_original_url, onError, jq_onerror, seeking, timeupdate, jq_onended, oncanplay;
                  return _regeneratorRuntime().wrap(function _callee32$(_context32) {
                    while (1) switch (_context32.prev = _context32.next) {
                      case 0:
                        t1 = Date.now(); // --- Cleanup
                        callback_called = false;
                        success = true;
                        ble_devices = undefined;
                        _this20.current_media = media;
                        _this20.current_media_options = options;
                        _this20.callback_caller = undefined;
                        onLoaded = function onLoaded() {
                          var report_preview = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                          // Wait till view is loaded
                          if (report_preview) _this20.reportPreview();
                        };
                        callback_caller = /*#__PURE__*/function () {
                          var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
                            var ret,
                              ble_count,
                              _args26 = arguments;
                            return _regeneratorRuntime().wrap(function _callee26$(_context26) {
                              while (1) switch (_context26.prev = _context26.next) {
                                case 0:
                                  ret = _args26.length > 0 && _args26[0] !== undefined ? _args26[0] : undefined;
                                  _this20.callback_caller = undefined;
                                  // remember which media was played last so we can prevent fading animation if same image will be shown again
                                  _this20.current_media = undefined;
                                  _this20.current_media_options = undefined;
                                  _this20.current_media_content_type = undefined;
                                  _this20.last_media = media;
                                  if (unregisterListeners) {
                                    unregisterListeners();
                                    unregisterListeners = undefined;
                                  }
                                  _this20.clearMediaTimeout({
                                    cleanup_stream: false,
                                    stop_video: false,
                                    comment: "Callback caller called"
                                  });
                                  console.log('AdFlow: ' + media._id + ' - Calling callback', ret);
                                  if (!options.scan_ble) {
                                    _context26.next = 19;
                                    break;
                                  }
                                  _context26.prev = 10;
                                  console.log("BLE: stopScan called");
                                  _context26.next = 14;
                                  return BleClient.stopLEScan();
                                case 14:
                                  _context26.next = 19;
                                  break;
                                case 16:
                                  _context26.prev = 16;
                                  _context26.t0 = _context26["catch"](10);
                                  console.log("BLE: error while stopScan: " + _context26.t0);
                                case 19:
                                  // -- Remove all event listeners
                                  $('#video').off();
                                  $('#img').off();
                                  // --
                                  if (!callback_called) {
                                    if (!ret) ret = {
                                      success: success
                                    };
                                    if (media._id) ret._id = media._id;
                                    if (ble_devices) {
                                      ble_count = Object.keys(ble_devices).length;
                                      console.log("BLE: found " + ble_count + " devices");
                                      ret.ble_count = ble_count;
                                    }
                                    resolve(ret);
                                    callback_called = true;
                                  }
                                case 22:
                                case "end":
                                  return _context26.stop();
                              }
                            }, _callee26, null, [[10, 16]]);
                          }));
                          return function callback_caller() {
                            return _ref12.apply(this, arguments);
                          };
                        }();
                        _this20.callback_caller = callback_caller;
                        // ---
                        _context32.prev = 10;
                        if (!(media && !media.url && !media.blob)) {
                          _context32.next = 22;
                          break;
                        }
                        _context32.next = 14;
                        return request({
                          url: '/medias/' + media._id,
                          method: 'GET',
                          silent: true
                        });
                      case 14:
                        media_object = _context32.sent;
                        media.constructing = media_object.constructing;
                        media.url = media_object.media;
                        if (!media.duration && media_object.duration) media.duration = media_object.duration;
                        if (!media.page_count && media_object.page_count) media.page_count = media_object.page_count;
                        if (!media.content_type && media_object.content_type) media.content_type = media_object.content_type;
                        if (!media.codecs && media_object.codecs) media.codecs = media_object.codecs;
                        if (!media.fragmented && media_object.fragmented) media.fragmented = media_object.fragmented;
                      case 22:
                        if (!(!media || media.constructing)) {
                          _context32.next = 25;
                          break;
                        }
                        // Don't show medias under construction
                        callback_caller({
                          success: false
                        });
                        return _context32.abrupt("return");
                      case 25:
                        if (!media.duration) media.duration = DEFAULT_DURATION;

                        // --- Watermark
                        if (options.branding && _this20.showBranding() || options.force_branding) $('#watermark').show();else $('#watermark').hide();
                        // ---
                        content_type = media.content_type;
                        url = media.url;
                        showing_loader = false;
                        if (!_this20.$refs.youtube.getVideoID(url)) {
                          _context32.next = 34;
                          break;
                        }
                        // Youtube
                        content_type = 'youtube';
                        _context32.next = 83;
                        break;
                      case 34:
                        _context32.prev = 34;
                        data_url_match = _this20.fileHelper.parseDataURL(url);
                        if (!media.blob) {
                          _context32.next = 41;
                          break;
                        }
                        url = URL.createObjectURL(media.blob);
                        content_type = media.blob.type;
                        _context32.next = 74;
                        break;
                      case 41:
                        if (!(media.caching != false && caching_available != false || data_url_match)) {
                          _context32.next = 74;
                          break;
                        }
                        _context32.next = 44;
                        return _this20.fileHelper.exists(url);
                      case 44:
                        _context32.t0 = !_context32.sent;
                        if (!_context32.t0) {
                          _context32.next = 47;
                          break;
                        }
                        _context32.t0 = !data_url_match;
                      case 47:
                        if (!_context32.t0) {
                          _context32.next = 68;
                          break;
                        }
                        mimeCodec = "".concat(content_type, "; codecs=\"").concat(media.codecs, "\""); // e.g. 'video/mp4; codecs="avc1.42E01E, mp4a.40.2"'
                        bg_download = true;
                        if (media.codecs && MediaSource.isTypeSupported(mimeCodec) && media.fragmented) {
                          // Interesting example of MediaSource with chunks
                          // https://gist.github.com/btotr/9249810

                          // Media must be fragmented
                          // media.url = "https://api.staging.eazyads.de/uploads/media/64d6240d473dddc51bb10fe8_frag.mp4"

                          bg_download = false;
                          // Download partially and feed MediaSource
                          try {
                            mediaSource = new MediaSource();
                            queue = [];
                            url_ori = media.url;
                            sourceopen = function sourceopen(e) {
                              if (mediaSource && mediaSource.readyState == 'open') {
                                var sourceBuffer = mediaSource.addSourceBuffer(mimeCodec);
                                sourceBuffer.mode = "segments";
                                sourceBuffer.addEventListener('update', function () {
                                  // Note: Have tried 'updateend'
                                  if (sourceBuffer && queue.length > 0 && !sourceBuffer.updating) {
                                    sourceBuffer.appendBuffer(queue.shift());
                                  }
                                });
                                _this20.fileHelper.downloadChunkedFile(url_ori, {
                                  onChunks: function onChunks(chunks) {
                                    try {
                                      if (callback_called) {
                                        if (mediaSource && mediaSource.readyState == 'open') {
                                          mediaSource.endOfStream();
                                          mediaSource.removeSourceBuffer(sourceBuffer);
                                        }
                                        sourceBuffer = null;
                                        mediaSource = null;
                                        return true;
                                      }
                                      if (sourceBuffer) {
                                        if (sourceBuffer.updating || queue.length > 0) queue.push(chunks);else sourceBuffer.appendBuffer(chunks);
                                      }
                                    } catch (e) {
                                      // alert(e)
                                      console.error(e);
                                      return true;
                                    }
                                  }
                                }).catch(function (e) {
                                  if (mediaSource && mediaSource.readyState == 'open') mediaSource.endOfStream();
                                  callback_caller({
                                    success: false,
                                    err: e
                                  });
                                }).then(function (x) {
                                  if (mediaSource && mediaSource.readyState == 'open') sourceBuffer.addEventListener('updateend', function () {
                                    mediaSource.endOfStream();
                                  });
                                });
                              }
                            };
                            mediaSource.addEventListener('sourceopen', sourceopen);
                            url = URL.createObjectURL(mediaSource);
                          } catch (e) {
                            bg_download = true;
                          }
                        }
                        if (!bg_download) {
                          _context32.next = 66;
                          break;
                        }
                        showing_loader = true;
                        $('#loading').show();
                        // Download file to cache in background for next time and use original URL for now
                        _this20.downloadFile(url).catch(function (e) {});
                        if (content_type) {
                          _context32.next = 66;
                          break;
                        }
                        _context32.prev = 56;
                        _context32.next = 59;
                        return axios({
                          url: url,
                          method: 'HEAD',
                          timeout: 3000,
                          // 1000ms leads to timeout in tizen emulator
                          responseType: 'blob'
                        });
                      case 59:
                        response = _context32.sent;
                        content_type = response.headers['content-type'];
                        _context32.next = 66;
                        break;
                      case 63:
                        _context32.prev = 63;
                        _context32.t1 = _context32["catch"](56);
                        content_type = guessContentType(url);
                      case 66:
                        _context32.next = 74;
                        break;
                      case 68:
                        _context32.next = 70;
                        return _this20.fileHelper.getFile(url, {
                          force_cached: !_this20.$socket.connected && url.startsWith(process.env.VUE_APP_BASE_API)
                        });
                      case 70:
                        data = _context32.sent;
                        // Avoid delay due to HEAD request when we know that we are offline
                        url = URL.createObjectURL(data.file);
                        if (!data.file.type) {
                          content_type = guessContentType(url);
                          data.file = data.file.slice(0, data.file.size, content_type);
                        }
                        content_type = data.file.type;
                      case 74:
                        if (!content_type || content_type.endsWith('/*')) content_type = guessContentType(url);
                        _context32.next = 82;
                        break;
                      case 77:
                        _context32.prev = 77;
                        _context32.t2 = _context32["catch"](34);
                        if (showing_loader) $('#loading').hide(); // Don't hide when shown from somewhere else
                        callback_caller({
                          success: false,
                          network_error: true,
                          err: _context32.t2
                        });
                        return _context32.abrupt("return");
                      case 82:
                        if (showing_loader) $('#loading').hide(); // Don't hide when shown from somewhere else
                      case 83:
                        // -- Remove currently running ad timeout if there is any to stop current playlist due to trouble when 2 playlists are played parallely
                        // console.log(`Current media: ${media._id}`)
                        _this20.pauseVideo(true, ['#video', '#youtube'], false); // Don't resolve the play promise here as we have already set a new one
                        _this20.clearMediaTimeout({
                          cleanup_stream: false,
                          stop_video: false,
                          reset_is_playing: false,
                          comment: "Stop currently running ad"
                        });
                        // --

                        // By default we don't want success to be true as this.onNext will also be called when user presses next button on remote
                        _this20.onNext = function () {
                          var ret = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                            next: true
                          };
                          _this20.clearMediaTimeout({
                            stop_video: false,
                            comment: "onNext"
                          }); // Prevent this.callback_caller to be called from here as we may need to called it with custom args
                          if (_this20.nextPage) {
                            _this20.nextPage();
                          } else {
                            callback_caller(ret);
                            _this20.pauseVideo(true, '#video');
                          }
                        };
                        _this20.onPrev = function () {
                          _this20.clearMediaTimeout({
                            stop_video: false,
                            comment: "onPrev"
                          }); // Prevent this.callback_caller to be called from here as we may need to called it with custom args
                          if (_this20.prevPage) {
                            _this20.prevPage();
                          } else {
                            callback_caller({
                              prev: true
                            });
                            _this20.pauseVideo(true, '#video');
                          }
                        };

                        // -- start BLE scan if requested
                        if (!options.scan_ble) {
                          _context32.next = 97;
                          break;
                        }
                        _context32.prev = 88;
                        console.log("BLE: Scanning for devices");
                        _context32.next = 92;
                        return BleClient.requestLEScan({}, function (result) {
                          var device_id = result.device.deviceId;
                          if (!ble_devices) ble_devices = {};
                          ble_devices[device_id] = ble_devices[device_id] === undefined ? 1 : ble_devices[device_id] + 1;
                          console.log("BLE: " + JSON.stringify(result.device));
                        });
                      case 92:
                        _context32.next = 97;
                        break;
                      case 94:
                        _context32.prev = 94;
                        _context32.t3 = _context32["catch"](88);
                        console.log("BLE: Error while scanning: " + _context32.t3);
                      case 97:
                        // --
                        t2 = Date.now(); // add loading time to {start_at}
                        loading_time = (t2 - t1) / 1000;
                        console.log("Loading time: " + loading_time);
                        start_at = options.start_at || 0;
                        if (start_at > 0) start_at += loading_time;
                        //  if (media.duration-start_at <= 0) => skip + carry over to next media?
                        if (content_type) {
                          _context32.next = 105;
                          break;
                        }
                        callback_caller({
                          success: false,
                          err: "Could not detect content type"
                        });
                        return _context32.abrupt("return");
                      case 105:
                        _this20.current_media_content_type = content_type;
                        _this20.playing_media = true;
                        _this20.$emit("onStatusChanged", {
                          playing: true,
                          media: media
                        });
                        if (!(content_type == 'youtube')) {
                          _context32.next = 123;
                          break;
                        }
                        // Make sure we always use a fresh iframe to avoid playing muted after interuption
                        // this.$refs.youtube.stop() // => stop already called in pauseVideo so no need to call again
                        _this20.show('#youtube');
                        _this20.$refs.youtube.setEventListener(function (evt, data) {
                          if (evt == 'loaded') onLoaded(false); // Don't report preview here as it will report as paused > play event will send report
                          if (evt == 'pause' || evt == 'play') _this20.reportPreview();
                          // Seek event not working properly but will be automatically handled by reportPreview in play event as it video is paused and played when seeked
                        });
                        _context32.prev = 111;
                        _context32.next = 114;
                        return _this20.$refs.youtube.play(media.url, _this20.muteForced(), start_at);
                      case 114:
                        callback_caller({
                          success: true
                        });
                        _context32.next = 121;
                        break;
                      case 117:
                        _context32.prev = 117;
                        _context32.t4 = _context32["catch"](111);
                        success = false;
                        callback_caller({
                          success: false,
                          err: _context32.t4
                        });
                      case 121:
                        _context32.next = 187;
                        break;
                      case 123:
                        if (!content_type.startsWith("application/pdf")) {
                          _context32.next = 152;
                          break;
                        }
                        _context32.next = 126;
                        return _this20.show();
                      case 126:
                        page = start_at / media.duration;
                        iPage = parseInt(page);
                        rest = page - iPage;
                        start_at_new = rest * media.duration;
                        console.log("Media ".concat(start_at, " / ").concat(media.duration, " = ").concat(page, " => ").concat(iPage + 1, " (").concat(start_at_new.toFixed(2), " seconds)"));
                        start_at = start_at_new;
                        iPage++; // prevent page 0 => invalid page request

                        _this20.pdf_src = url;
                        _this20.pdf_page = iPage;
                        num_pages = media.page_count; // console.log('AdFlow: ' + ad.campaign.uuid + ' - Setting Timeout to ' + ad.campaign.ad_duration + ' Seconds (per Page)')
                        _this20.nextPage = function () {
                          var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                            next: true
                          };
                          if (_this20.pdf_page < num_pages) {
                            // Next Page
                            _this20.pdf_page++;
                            //console.log('AdFlow: ' + ad.campaign.uuid + ' - Page ' + this.pdf_page + '/' + num_pages)
                            // use start_at only for first page
                            _this20.setMediaTimeout(_this20.nextPage, media.duration * 1000, res);
                            start_at = 0; // use start_at only for first page
                            _this20.reportPreview();
                          } else {
                            // Next Ad
                            _this20.nextPage = undefined;
                            _this20.prevPage = undefined;
                            // Set success = true otherwise ad impressions won't be reported
                            _this20.onNext(res);
                          }
                        };
                        _this20.prevPage = function () {
                          if (_this20.pdf_page > 1) {
                            // Prev Page
                            _this20.pdf_page--;
                            //console.log('AdFlow: ' + ad.campaign.uuid + ' - Page ' + this.pdf_page + '/' + num_pages)
                            // use start_at only for first page - report success: true only if (last) page was nexted by timer (not by remote)
                            _this20.setMediaTimeout(_this20.nextPage, media.duration * 1000);
                            _this20.reportPreview();
                          } else {
                            // Prev Ad
                            _this20.nextPage = undefined;
                            _this20.prevPage = undefined;
                            _this20.onPrev();
                          }
                        };
                        setPDFLoadTimeout = function setPDFLoadTimeout() {
                          var seconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
                          _this20.pdfLoadTimeout = setTimeout(function () {
                            pdfErrorListener('Timeout');
                          }, seconds * 1000);
                        };
                        clearPDFLoadTimeout = function clearPDFLoadTimeout() {
                          if (_this20.pdfLoadTimeout) clearTimeout(_this20.pdfLoadTimeout);
                        };
                        pdfNumPagesListener = function pdfNumPagesListener(n) {
                          if (n) {
                            num_pages = n;
                            //console.log('AdFlow: ' + ad.campaign.uuid + ' - Page ' + this.pdf_page + '/' + num_pages)
                          }
                        };
                        pdfErrorListener = function pdfErrorListener(e) {
                          URL.revokeObjectURL(url);
                          clearPDFLoadTimeout();
                          console.log('PDF error: ' + e);
                          _this20.clearMediaTimeout({
                            cleanup_stream: false,
                            stop_video: false,
                            comment: "PDF Load error"
                          }); // If pdf.loaded was called but pdf.rendered was not called, prevent promise to be resolved with success
                          success = false;
                          callback_caller({
                            success: false,
                            err: e
                          });
                          // Test: retry with original URL => not working properly
                          /*
                          if (url == media.url) {
                            success = false
                            callback_caller({success: false, err: e})
                          } else {
                            console.log("Retrying PDF with original URL")
                            url = media.url
                            this.pdf_src = url
                            setPDFLoadTimeout()
                          }
                          */
                        };

                        _this20.pdfLoadTimeout = setTimeout(function () {
                          pdfErrorListener('Timeout');
                        }, 10 * 1000);
                        pdfPageRenderedListener = /*#__PURE__*/function () {
                          var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee27(page) {
                            var pass_args_via_timeout;
                            return _regeneratorRuntime().wrap(function _callee27$(_context27) {
                              while (1) switch (_context27.prev = _context27.next) {
                                case 0:
                                  clearPDFLoadTimeout();
                                  _context27.next = 3;
                                  return _this20.show('#pdf');
                                case 3:
                                  // Make sure PDF is visible
                                  if (_this20.pdfLoadTimeout) {
                                    clearTimeout(_this20.pdfLoadTimeout);
                                    _this20.pdfLoadTimeout = undefined;
                                  }
                                  console.log('Rendered page ' + page);

                                  // report success: true only if pass_args_via_timeout was passed through from first to last page when being nexted by timer (not by remote)
                                  pass_args_via_timeout = {
                                    success: true
                                  };
                                  _this20.setMediaTimeout(_this20.nextPage, (media.duration - start_at) * 1000, pass_args_via_timeout);
                                case 7:
                                case "end":
                                  return _context27.stop();
                              }
                            }, _callee27);
                          }));
                          return function pdfPageRenderedListener(_x7) {
                            return _ref13.apply(this, arguments);
                          };
                        }();
                        pdfLoadedListener = /*#__PURE__*/function () {
                          var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
                            return _regeneratorRuntime().wrap(function _callee28$(_context28) {
                              while (1) switch (_context28.prev = _context28.next) {
                                case 0:
                                  _context28.next = 2;
                                  return _this20.show('#pdf');
                                case 2:
                                  clearPDFLoadTimeout();
                                  setPDFLoadTimeout(15); // PDF is loaded, give 15 seconds time to render otherwise timeout
                                  onLoaded();
                                case 5:
                                case "end":
                                  return _context28.stop();
                              }
                            }, _callee28);
                          }));
                          return function pdfLoadedListener() {
                            return _ref14.apply(this, arguments);
                          };
                        }();
                        unregisterListeners = function unregisterListeners() {
                          // called in callback_caller
                          _this20.$refs.pdf.$off('loaded', pdfLoadedListener);
                          _this20.$refs.pdf.$off('error', pdfErrorListener);
                          _this20.$refs.pdf.$off('num-pages', pdfNumPagesListener);
                          _this20.$refs.pdf.$off('page-rendered', pdfPageRenderedListener);
                          if (url == media.url) URL.revokeObjectURL(url);
                        };
                        _this20.$refs.pdf.$on('loaded', pdfLoadedListener);
                        _this20.$refs.pdf.$on('num-pages', pdfNumPagesListener);
                        _this20.$refs.pdf.$on('error', pdfErrorListener);
                        _this20.$refs.pdf.$on('page-rendered', pdfPageRenderedListener);
                        _context32.next = 187;
                        break;
                      case 152:
                        if (!content_type.startsWith('text/html')) {
                          _context32.next = 160;
                          break;
                        }
                        _context32.next = 155;
                        return _this20.show();
                      case 155:
                        // iFrame not working in mobile apps => use div and set v-html
                        // this.html_content = await data.file.text() => Android: data.file.text is not a fucntion
                        reader = new FileReader();
                        reader.onload = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
                          return _regeneratorRuntime().wrap(function _callee29$(_context29) {
                            while (1) switch (_context29.prev = _context29.next) {
                              case 0:
                                _this20.html_content = reader.result;
                                _context29.next = 3;
                                return _this20.show('#iframe');
                              case 3:
                                onLoaded();
                                _this20.setMediaTimeout(callback_caller, (media.duration - start_at) * 1000, {
                                  success: true
                                });
                                _this20.$forceUpdate();
                              case 6:
                              case "end":
                                return _context29.stop();
                            }
                          }, _callee29);
                        }));
                        reader.readAsText(data.file);
                        _context32.next = 187;
                        break;
                      case 160:
                        if (!content_type.startsWith('image')) {
                          _context32.next = 178;
                          break;
                        }
                        same_img = false;
                        onerror = function onerror(e) {
                          URL.revokeObjectURL(url);
                          // console.log('AdFlow: ' + ad.campaign.uuid + ' - Image error: ' + e)
                          success = false;
                          callback_caller({
                            success: false,
                            err: e
                          });
                        };
                        onload = /*#__PURE__*/function () {
                          var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee30() {
                            var same_img,
                              _args30 = arguments;
                            return _regeneratorRuntime().wrap(function _callee30$(_context30) {
                              while (1) switch (_context30.prev = _context30.next) {
                                case 0:
                                  same_img = _args30.length > 0 && _args30[0] !== undefined ? _args30[0] : false;
                                  if (!(!same_img || !$('#img').is(':visible'))) {
                                    _context30.next = 5;
                                    break;
                                  }
                                  _this20.show('#img_wrapper');
                                  _context30.next = 5;
                                  return _this20.show('#img');
                                case 5:
                                  onLoaded();
                                  URL.revokeObjectURL(url);
                                  // console.log('AdFlow: ' + ad.campaign.uuid + ' - Image displayed')
                                  _this20.setMediaTimeout(callback_caller, (media.duration - start_at) * 1000, {
                                    success: true
                                  });
                                case 8:
                                case "end":
                                  return _context30.stop();
                              }
                            }, _callee30);
                          }));
                          return function onload() {
                            return _ref16.apply(this, arguments);
                          };
                        }();
                        if (!(_this20.last_media && _this20.last_media.url == media.url && _this20.getCurrentView() == '#img')) {
                          _context32.next = 170;
                          break;
                        }
                        // if last image was same image as this one, prevent fade
                        same_img = true;
                        // Reset timeout as "load" will not be called
                        _context32.next = 168;
                        return onload(same_img);
                      case 168:
                        _context32.next = 172;
                        break;
                      case 170:
                        _context32.next = 172;
                        return _this20.show();
                      case 172:
                        if ($('#img')[0] && !same_img) $('#img')[0].src = url;
                        // console.log('AdFlow: ' + ad.campaign.uuid + ' - Setting Timeout to ' + ad.campaign.ad_duration + ' Seconds')

                        $('#img').on('error', onerror);
                        $('#img').on('load', onload);
                        unregisterListeners = function unregisterListeners() {
                          $('#img').off('load', onload);
                          $('#img').off('error', onerror);
                        };
                        _context32.next = 187;
                        break;
                      case 178:
                        if (!content_type.startsWith('video')) {
                          _context32.next = 185;
                          break;
                        }
                        _context32.next = 181;
                        return _this20.show();
                      case 181:
                        video_elem = $('#video')[0];
                        if (video_elem) {
                          video_elem.removeAttribute('src');
                          while (video_elem.firstChild) {
                            video_elem.removeChild(video_elem.lastChild);
                          }
                          source = document.createElement('source');
                          source.src = url;
                          if (!content_type.endsWith('/*')) source.type = content_type;
                          // -- video/quicktime => video/mp4
                          // 13.01.2023: mov-files won't work on FireTV with content-type video/quicktime but it works when passing video/mp4
                          if (source.type == 'video/quicktime') source.type = 'video/mp4';
                          // --
                          video_elem.appendChild(source);
                          video_elem.load();
                          video_elem.controls = options.controls;
                          video_elem.currentTime = start_at;
                          video_elem.poster = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
                          _this20.clearVideoLoadTimeout();
                          trying_original_url = url == media.url; // --- Error handling
                          onError = /*#__PURE__*/function () {
                            var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee31(err) {
                              return _regeneratorRuntime().wrap(function _callee31$(_context31) {
                                while (1) switch (_context31.prev = _context31.next) {
                                  case 0:
                                    if (err) console.log(err);
                                    URL.revokeObjectURL(url);
                                    if (trying_original_url) {
                                      _context31.next = 8;
                                      break;
                                    }
                                    // Retry with original URL
                                    source.src = media.url;
                                    trying_original_url = true;
                                    video_elem.load();
                                    _context31.next = 24;
                                    break;
                                  case 8:
                                    if (!(data && data.cached)) {
                                      _context31.next = 21;
                                      break;
                                    }
                                    if (!(err && err.message && err.message.includes('PIPELINE_ERROR_DECODE'))) {
                                      _context31.next = 12;
                                      break;
                                    }
                                    _context31.next = 21;
                                    break;
                                  case 12:
                                    _context31.prev = 12;
                                    _context31.next = 15;
                                    return _this20.fileHelper.deleteFile(media.url);
                                  case 15:
                                    _context31.next = 19;
                                    break;
                                  case 17:
                                    _context31.prev = 17;
                                    _context31.t0 = _context31["catch"](12);
                                  case 19:
                                    if (attempts_play_cached >= 3) {
                                      console.log("Disabling caching after ".concat(attempts_play_cached, " failures"));
                                      caching_available = false;
                                    }
                                    attempts_play_cached++;
                                  case 21:
                                    // console.log('AdFlow: ' + ad.campaign.uuid + ' - Video error: ' + JSON.stringify(e) + (data.cached ? ' => deleted cached file' : '') )
                                    success = false;
                                    callback_caller({
                                      success: false,
                                      err: err
                                    });
                                    onError = undefined; // prevent double call (jquery error / addEventListener Error)
                                  case 24:
                                  case "end":
                                    return _context31.stop();
                                }
                              }, _callee31, null, [[12, 17]]);
                            }));
                            return function onError(_x8) {
                              return _ref17.apply(this, arguments);
                            };
                          }();
                          jq_onerror = function jq_onerror(e) {
                            // alert(video_elem.error.message)
                            if (onError) onError(video_elem.error);
                          };
                          $('#video').on('error', jq_onerror); // jquery error evt not called from all devices (e.g. Firefox)

                          // --- Workaround for seek detection (onseeked not working properly)
                          seeking = false;
                          video_elem.onseeking = function (event) {
                            seeking = true;
                          };
                          video_elem.onplay = function (event) {
                            if (seeking) {
                              // console.log("Seek done")
                              seeking = false;
                            }
                            _this20.reportPreview();
                          };
                          video_elem.onpause = function (event) {
                            // Avoid sending pause event when video has ended
                            if (!video_elem.ended) {
                              _this20.reportPreview();
                            }
                          };
                          // ---
                          onerror = function onerror(event) {
                            var error;

                            // Chrome v60
                            if (event.path && event.path[0] && event.path[0].error) {
                              error = event.path[0].error;
                            }

                            // Firefox v55
                            if (event.originalTarget && event.originalTarget.error) {
                              error = event.originalTarget.error;
                            }

                            // Searching for message in WebOS but seems to be empty
                            if (event.target && event.target.error) {
                              error = event.target.error;
                            }

                            // Here comes the error message
                            // if (error)
                            //   alert(`Video error: ${error.message}`);

                            if (onError) onError(error);
                          };
                          video_elem.addEventListener('error', onerror, true);
                          _this20.videoLoadTimeout = setTimeout(function () {
                            // In case we have a video that can't be loaded but 'error' is not called (e.g. h2.65 codec)
                            // Timeout is cleared in clearTimeout
                            success = false;
                            callback_caller({
                              success: false,
                              err: 'Timeout'
                            });
                          }, 10 * 1000); // Increasing timeout due to tizen emulator
                          // ----

                          video_elem.onloadedmetadata = function () {
                            // console.log('AdFlow: ' + ad.campaign.uuid + ' - Meta loaded')
                            if (!callback_called) {
                              _this20.clearMediaTimeout({
                                cleanup_stream: false,
                                stop_video: false,
                                reset_is_playing: false,
                                comment: "Video meta loaded"
                              });
                              _this20.show('#video').then(function () {
                                onLoaded(false); // avoid double call of report preview as onplay will also call

                                document.getElementById('video_overlay').setAttribute("style", "width:".concat(video_elem.offsetWidth, "px; height:").concat(video_elem.offsetHeight, "px;"));
                                if (media.subtitles) {
                                  timeupdate = function timeupdate() {
                                    var currentTime = video_elem.currentTime;
                                    var style = "";
                                    if (media.subtitles_style) style = media.subtitles_style;
                                    style += "display: " + ($('#subtitles').is(':visible') ? 'block' : 'none') + ';';
                                    var fadeout = false;
                                    var point = media.subtitles.find(function (x) {
                                      return currentTime >= x.start && currentTime < x.end;
                                    });
                                    if (point) {
                                      if (point.style) style += point.style;
                                      if (currentTime >= point.start && currentTime < point.end) {
                                        if ($('#subtitles').text() != point.text) $('#subtitles').text(point.text);
                                        if (!$('#subtitles').is(':visible')) {
                                          $('#subtitles')[0].style.cssText = style;
                                          $('#subtitles').fadeIn();
                                        }
                                      } else if (currentTime >= point.end) {
                                        fadeout = true;
                                      }
                                    } else fadeout = true;
                                    if (fadeout && $('#subtitles').is(':visible')) {
                                      $('#subtitles').fadeOut();
                                    }
                                  };
                                  video_elem.addEventListener('timeupdate', timeupdate, false);
                                }
                              });
                              jq_onended = function jq_onended() {
                                URL.revokeObjectURL(url);
                                // console.log('AdFlow: ' + ad.campaign.uuid + ' - Video ended')
                                callback_caller({
                                  success: true
                                });
                              };
                              $('#video').on('ended', jq_onended);

                              //console.log('AdFlow: ' + ad.campaign.uuid + ' - Playing video')
                              // video_elem.playbackRate = 3 // Debug: Faster video play
                              //video_elem.removeAttribute('muted')
                              if (_this20.muteForced()) video_elem.muted = true;
                              video_elem.removeAttribute('autoplay');
                              video_elem.volume = 1;

                              // ---
                              var trial = 0;
                              var playedPromise = video_elem.play();
                              if (playedPromise) {
                                var onPlaying = function onPlaying() {
                                  if (data && data.cached) {
                                    attempts_play_cached = 0;
                                  }
                                  var start_at = options.start_at || 0;
                                  if (start_at > 0) {
                                    var t3 = Date.now();
                                    var loading_time = (t3 - t1) / 1000;
                                    var play_at = start_at + loading_time;
                                    console.log("Playing at " + play_at);
                                    video_elem.currentTime = play_at;
                                  }
                                };
                                var onPlayError = function onPlayError(e) {
                                  console.log(e);
                                  if (!e || !String(e).includes("pause")) {
                                    // Don't play when "The play() request was interrupted by a call to pause()"
                                    trial++;
                                    if (trial >= 3) {
                                      console.log("Playing muted");
                                      video_elem.autoplay = true;
                                      video_elem.muted = true;
                                    }
                                    if (trial <= 5) video_elem.play().then(onPlaying).catch(onPlayError);else {
                                      success = false;
                                      callback_caller({
                                        success: false,
                                        err: e
                                      });
                                    }
                                  }
                                };
                                playedPromise.then(onPlaying);
                                playedPromise.catch(onPlayError);
                              }
                            } else {
                              // console.log('AdFlow: ' + ad.campaign.uuid + ' - Not playing because callback was called already')
                            }
                          };
                          oncanplay = function oncanplay() {
                            // Not called in iOS => Using onloadedmetadata
                            // console.log('AdFlow: ' + ad.campaign.uuid + ' - Video ready')
                          };
                          video_elem.addEventListener('oncanplay', oncanplay, false);
                          unregisterListeners = function unregisterListeners() {
                            console.log("Unregistering all video listeners");
                            // called in callback_caller
                            video_elem.removeEventListener('oncanplay', oncanplay, false);
                            if (timeupdate) video_elem.removeEventListener('timeupdate', timeupdate, false);
                            video_elem.removeEventListener('error', onerror, true);
                            $('#video').off('error', jq_onerror);
                            video_elem.onseeking = undefined;
                            video_elem.onplay = undefined;
                            video_elem.onpause = undefined;
                            video_elem.onloadedmetadata = undefined;
                            if (mediaSource && sourceopen) mediaSource.removeEventListener('sourceopen', sourceopen);
                            if (jq_onended) $('#video').off('ended', jq_onended);
                            URL.revokeObjectURL(url);
                          };
                        }
                        _context32.next = 187;
                        break;
                      case 185:
                        // Unknown content type
                        success = false;
                        callback_caller({
                          success: false,
                          err: 'Unsupported content-type ' + content_type
                        });
                      case 187:
                        _context32.next = 193;
                        break;
                      case 189:
                        _context32.prev = 189;
                        _context32.t5 = _context32["catch"](10);
                        _this20.clearMediaTimeout({
                          comment: "Exception caught"
                        });
                        callback_caller({
                          success: false,
                          err: _context32.t5
                        });
                      case 193:
                      case "end":
                        return _context32.stop();
                    }
                  }, _callee32, null, [[10, 189], [34, 77], [56, 63], [88, 94], [111, 117]]);
                }));
                return function (_x6) {
                  return _ref11.apply(this, arguments);
                };
              }());
              _this20.playPromise.then(function () {
                _this20.playPromise = undefined;
              });
              return _context33.abrupt("return", _this20.playPromise);
            case 12:
            case "end":
              return _context33.stop();
          }
        }, _callee33);
      }))();
    },
    seekTo: function seekTo(sec) {
      var current_view = this.getCurrentView();
      if (current_view == '#youtube') {
        this.$refs.youtube.seekTo(sec);
      } else if (current_view == '#video') {
        var video_elem = $('#video')[0];
        video_elem.currentTime = sec;
      }
    },
    fastforward: function fastforward() {
      var current_view = this.getCurrentView();
      if (current_view == '#youtube') {
        this.$refs.youtube.fastforward(10);
      } else if (current_view == '#video') {
        var video_elem = $('#video')[0];
        video_elem.currentTime += 10;
      } else if (this.onNext) {
        this.onNext();
      }
    },
    rewind: function rewind() {
      var current_view = this.getCurrentView();
      if (current_view == '#youtube') {
        this.$refs.youtube.rewind(10);
      } else if (current_view == '#video') {
        var video_elem = $('#video')[0];
        video_elem.currentTime -= 10;
      } else if (this.onPrev) {
        this.onPrev();
      }
    },
    setStartTimeout: function setStartTimeout(startAt) {
      var _this21 = this;
      // startAt is the target time (e.g. 08:00) so we need to set the timer at local time
      // e.g. Server is 2 mins ahead (ts_diff= -120k)
      // => 08:00 + (-2mins) = 07:58
      // console.log(`${now.format('DD.MM.YYYY HH:mm:ss')} filterEntries`)

      this.clearStartTimeout();
      this.startTimeout = executeAt('startTimeout', function () {
        if (!_this21.interrupted) _this21.seekCurrentSchedulePosition();
      }, moment(startAt + this.ts_diff));
      // console.log(`${moment(startAt + this.ts_diff).format('DD.MM.YYYY HH:mm:ss')} setStartTimeout`)
    },
    clearStartTimeout: function clearStartTimeout() {
      clearExecuteAt('startTimeout');
      this.startTimeout = undefined;
    },
    setEndTimeout: function setEndTimeout(endAt, id) {
      var _this22 = this;
      // endAt is the target time (e.g. 08:05) so we need to set the timer at local time
      // e.g. Server is 2 mins ahead (ts_diff= -120k)
      // => 08:05 + (-2mins) = 08:03
      // console.log(`${now.format('DD.MM.YYYY HH:mm:ss')} filterEntries`)

      executeAt('endTimeout_' + id, function (playlist_id) {
        if (_this22.current_playlist == playlist_id) {
          if (!_this22.interrupted) {
            _this22.clearMediaTimeout({
              comment: "Playlist ended according to schedule",
              stop_video: true,
              callback_caller_args: {
                success: false,
                end_loop: true
              }
            });
            setTimeout(function () {
              // Post delayed to avoid time overlapping with the current entry which just ended
              _this22.seekCurrentSchedulePosition();
            }, 100);
          }
        }
      }, moment(endAt + this.ts_diff), id);
      // console.log(`${moment(endAt + this.ts_diff).format('DD.MM.YYYY HH:mm:ss')} setEndTimeout`)
    },
    clearEndTimeout: function clearEndTimeout() {},
    clearVideoLoadTimeout: function clearVideoLoadTimeout() {
      if (this.videoLoadTimeout) {
        // Clear video timeout timer => prevents video timeout error
        clearTimeout(this.videoLoadTimeout);
        this.videoLoadTimeout = undefined;
      }
    },
    clearMediaTimeout: function clearMediaTimeout() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var default_options = {
        cleanup_stream: true,
        stop_video: true,
        reset_is_playing: true,
        callback_caller_args: undefined
      };
      mergeObject(default_options, options);
      // console.log(options)

      if (options.reset_is_playing) {
        if (this.playing_media != false) this.$emit("onStatusChanged", {
          playing: false
        });
        this.playing_media = false;
      }
      if (options.callback_caller_args && this.callback_caller) {
        this.callback_caller(options.callback_caller_args);
      }
      this.clearVideoLoadTimeout();
      if (options.stop_video) this.pauseVideo(true);
      // -- 03.05.2023 15:00 Cleans up RTSP Stream before it even really starts
      if (this.cleanup && options.cleanup_stream) this.cleanup({
        seek_schedule: false
      });
      // --

      if (this.mediaTimeout != undefined) {
        clearTimeout(this.mediaTimeout);
        // console.log("Clearing timeout " + this.mediaTimeout)
        this.mediaTimeout = undefined;
        this.mediaTimeoutStart = undefined;
        return true;
      }
      return false;
    },
    setMediaTimeout: function setMediaTimeout(callback, ms) {
      this.clearMediaTimeout({
        cleanup_stream: false,
        stop_video: false,
        reset_is_playing: false,
        comment: "Setting new media timeout"
      });
      if (ms < 0) return undefined;
      this.mediaTimeoutStart = Date.now();
      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }
      this.mediaTimeout = setTimeout.apply(void 0, [callback, ms].concat(args));
      // console.log("Setting timeout " + this.mediaTimeout)
      return this.mediaTimeout;
    },
    getCurrentView: function getCurrentView() {
      var all = ['#pdf', '#iframe', '#video_stream', '#video', '#youtube', '#img', '#fallback'];
      for (var i = 0; i < all.length; i++) {
        if ($(all[i]).is(":visible")) return all[i];
      }
    },
    show: function show() {
      var _this23 = this;
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      var fade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return new Promise( /*#__PURE__*/function () {
        var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee34(resolve) {
          var all, promises, i, video_elem;
          return _regeneratorRuntime().wrap(function _callee34$(_context34) {
            while (1) switch (_context34.prev = _context34.next) {
              case 0:
                // -- hide all except id
                all = ['#pdf', '#iframe', '#video_stream', '#video', '#youtube', '#img', '#img_wrapper', '#fallback'];
                promises = [];
                for (i = 0; i < all.length; i++) {
                  if (id != all[i]) {
                    // --- Pause video when hiding element
                    if (all[i] == '#video' || all[i] == '#video_stream') {
                      video_elem = $(all[i])[0];
                      if (video_elem) video_elem.pause();
                      $('#video_overlay').hide();
                      $('#subtitles').text("");
                      if ($('#subtitles')[0]) $('#subtitles')[0].style.cssText = "";
                    } else if (all[i] == '#youtube' && _this23.$refs.youtube) {
                      _this23.$refs.youtube.pause();
                    }
                    // --- Remove clock interval (clock is only shown in fallback)
                    if (all[i] == '#fallback') _this23.clearClockInterval();
                    if (fade) promises.push(new Promise(function (resolve) {
                      $(all[i]).fadeOut(function () {
                        resolve();
                      });
                    }));else $(all[i]).hide();
                  }
                }
                if (!(promises.length > 0)) {
                  _context34.next = 6;
                  break;
                }
                _context34.next = 6;
                return Promise.all(promises);
              case 6:
                // --
                if (id) {
                  if (id == '#video' || id == '#video_stream') $('#video_overlay').show();
                  if (fade) {
                    $(id).fadeIn(function () {
                      resolve();
                    });
                  } else {
                    $(id).show();
                    resolve();
                  }
                } else resolve();
              case 7:
              case "end":
                return _context34.stop();
            }
          }, _callee34);
        }));
        return function (_x9) {
          return _ref18.apply(this, arguments);
        };
      }());
    },
    // --- Fallbacks
    clearClockInterval: function clearClockInterval() {
      if (this.clock_interval) clearInterval(this.clock_interval);
    },
    showWaitingForSchedule: function showWaitingForSchedule() {
      this.showFallback('waiting_for_schedule', process.env.VUE_APP_APP_URL + '/screens/' + this.screen_id);
    },
    showFallback: function showFallback() {
      var _this24 = this;
      var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      var text_args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var onInterval = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
      // --- Realtime clock
      this.clearClockInterval();
      this.clock_interval = setInterval(function () {
        // https://stackoverflow.com/a/64947352
        _this24.date = Intl.DateTimeFormat(navigator.language, {
          dateStyle: 'full'
        }).format();
        _this24.time = Intl.DateTimeFormat(navigator.language, {
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric'
        }).format();
        if (onInterval) onInterval();
      }, 1000);
      // ---

      if (!text) {
        text = 'fallback_text'; // do this.$t(...) in HTML part to make dynamic language change work
        url = process.env.VUE_APP_APP_URL + '/advertise/' + this.screen_id;
      }
      this.fallback_text = this.$t(text, text_args);
      this.fallback_qr_url = url;
      this.pauseVideo(true);
      this.current_media = undefined;
      this.current_media_options = undefined;
      this.current_media_content_type = undefined;
      $('#watermark').hide();
      this.show('#fallback').then(function () {
        _this24.reportPreview();
      });
      this.$forceUpdate();
    },
    canPlayOffline: function canPlayOffline() {
      var _this25 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee35() {
        var schedule, _this25$filterEntries, filtered_entries, next_entry;
        return _regeneratorRuntime().wrap(function _callee35$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              _context35.prev = 0;
              _context35.next = 3;
              return _this25.retrieveSubscription();
            case 3:
              if (!(_this25.subscription.offline_usage && caching_available != false)) {
                _context35.next = 14;
                break;
              }
              _context35.next = 6;
              return FILE_HELPER.readJSONFile('schedule');
            case 6:
              schedule = _context35.sent;
              if (!schedule) {
                _context35.next = 14;
                break;
              }
              if (!_this25.schedule) _this25.schedule = schedule;
              if (!_this25.schedule.identifier) {
                _context35.next = 11;
                break;
              }
              return _context35.abrupt("return", true);
            case 11:
              _this25$filterEntries = _this25.filterEntries(), filtered_entries = _this25$filterEntries.filtered_entries, next_entry = _this25$filterEntries.next_entry;
              if (!(filtered_entries.find(function (x) {
                return x.slot_type == 'internal';
              }) || next_entry && next_entry.slot_type == 'internal')) {
                _context35.next = 14;
                break;
              }
              return _context35.abrupt("return", true);
            case 14:
              return _context35.abrupt("return", false);
            case 17:
              _context35.prev = 17;
              _context35.t0 = _context35["catch"](0);
              return _context35.abrupt("return", false);
            case 20:
            case "end":
              return _context35.stop();
          }
        }, _callee35, null, [[0, 17]]);
      }))();
    },
    filterEntries: function filterEntries() {
      var schedule = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.schedule;
      var now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : moment(Date.now() - this.ts_diff);
      // We need to substract ts_diff here as we want "now" to be the server time
      // e.g. Server is 2 mins ahead (ts_diff= -120k) and we land here at 07:58 local time
      // => 07:58 - (-2mins) = 08:00
      // console.log(`${now.format('DD.MM.YYYY HH:mm:ss')} filterEntries`)
      // filter all entries where {now} is between start and end => All playlists which can be currently played according to the schedule
      var next_entry;
      var filtered_entries = schedule.entries.filter(function (x) {
        // No need to add ts_diff here as start and end are absolute times (e.g. from 08:30 - 09:00) and we want to check if NOW is in between start and end
        x.start = moment().startOf('isoWeek').weekday(x.start_day).startOf('day').add(x.start_time);
        x.end = moment(x.start).add(x.duration);
        while (now > x.end) {
          // if slot has passed => take next week
          x.start.add(7, 'days');
          x.end = moment(x.start).add(x.duration);
        }
        if (now >= x.start && now < x.end) {
          var tmp = x.ellapsed;
          x.ellapsed = now - x.start;
          console.log("".concat(moment(now).format('DD.MM.YYYY HH:mm:ss'), " Elapsed: ").concat(x.ellapsed / 1000, " => ").concat(tmp ? (x.ellapsed - tmp) / 1000 : 0, " Sec"));
          return true;
        }
        if (now < x.start && (!next_entry || next_entry.start > x.start)) next_entry = x;
      });
      return {
        filtered_entries: filtered_entries,
        next_entry: next_entry
      };
    },
    retrieveSubscription: function retrieveSubscription() {
      var _this26 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee36() {
        var now;
        return _regeneratorRuntime().wrap(function _callee36$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              _context36.prev = 0;
              now = moment();
              if (!(!_this26.last_subscription_request || now - _this26.last_subscription_request > 10000)) {
                _context36.next = 7;
                break;
              }
              // Make sure there's a gap between 2 requests otherwise second request will end with error
              _this26.last_subscription_request = now;
              _context36.next = 6;
              return request({
                url: '/subscription',
                method: 'GET',
                silent: true
              });
            case 6:
              _this26.subscription = _context36.sent;
            case 7:
              _context36.next = 12;
              break;
            case 9:
              _context36.prev = 9;
              _context36.t0 = _context36["catch"](0);
              _this26.subscription = {
                branding: true
              };
            case 12:
            case "end":
              return _context36.stop();
          }
        }, _callee36, null, [[0, 9]]);
      }))();
    },
    // --- Breaking news
    show_breaking_news: function show_breaking_news(data) {
      var _this27 = this;
      $('#breaking-news').removeClass('slide-out');
      $('#breaking-news').addClass('slide-in');
      this.breaking_news = data;
      document.querySelector('#breaking-news').addEventListener('animationend', function (evt) {
        if (evt.animationName == 'slide-out') {
          _this27.breaking_news = {};
        }
        if (evt.animationName == 'marquee') {
          // Fade out when marquee has ended
          $('#breaking-news').addClass('slide-out');
        }
      });
    },
    // ---
    isPlayerVisible: function isPlayerVisible() {
      return $('#wrapper').is(":visible");
    },
    showBranding: function showBranding() {
      return this.subscription.branding;
    },
    muteForced: function muteForced() {
      var urlParams = new URLSearchParams(window.location.search);
      var mute = urlParams.get('mute');
      if (mute) {
        if (mute == true || mute.toLowerCase() === 'true') return true;
      }
      return false;
    },
    clearCache: function clearCache() {
      var _this28 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee37() {
        return _regeneratorRuntime().wrap(function _callee37$(_context37) {
          while (1) switch (_context37.prev = _context37.next) {
            case 0:
              _context37.prev = 0;
              _context37.next = 3;
              return _this28.fileHelper.clearCache();
            case 3:
              _context37.next = 8;
              break;
            case 5:
              _context37.prev = 5;
              _context37.t0 = _context37["catch"](0);
              // console.log(e)
              console.log("Error clearing cache: " + _context37.t0.message);
            case 8:
            case "end":
              return _context37.stop();
          }
        }, _callee37, null, [[0, 5]]);
      }))();
    }
  }
};